"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/machines/excess-settlement-funds-manager-machine/index.ts
var excess_settlement_funds_manager_machine_exports = {};
__export(excess_settlement_funds_manager_machine_exports, {
  excessSettlementFundsManagerMachine: () => excessSettlementFundsManagerMachine
});
module.exports = __toCommonJS(excess_settlement_funds_manager_machine_exports);
var import_xstate10 = require("xstate");

// src/generated/graphql.ts
var ReceiptSettlementDataFragmentDoc = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "ReceiptSettlementData" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "receipt_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "project" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "index" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "featured_token" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "media_url" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "vertical_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vertical" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "display_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "category_name" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_type" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "project_minter_configuration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "extra_minter_details" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "excess_settlement_funds" } }] } }] };
var ProjectDetailsFragmentDoc = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "ProjectDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "projects_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artist_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artist_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "complete" } }, { "kind": "Field", "name": { "kind": "Name", "value": "start_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "auction_start_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "auction_end_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "aspect_ratio" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "invocations" } }, { "kind": "Field", "name": { "kind": "Name", "value": "max_invocations" } }, { "kind": "Field", "name": { "kind": "Name", "value": "paused" } }, { "kind": "Field", "name": { "kind": "Name", "value": "featured_token" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "media_url" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "default_vertical" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "category" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "hosted" } }] } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_configuration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "MinterConfigurationDetails" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "MinterDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "minters_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "description_template" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "MinterConfigurationDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "project_minter_configurations" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "currency_symbol" } }, { "kind": "Field", "name": { "kind": "Name", "value": "currency_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "base_price" } }, { "kind": "Field", "name": { "kind": "Name", "value": "extra_minter_details" } }, { "kind": "Field", "name": { "kind": "Name", "value": "offchain_extra_minter_details" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "MinterDetails" } }] } }] } }] };
var BidDetailsFragmentDoc = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "BidDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "bids_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "slot_index" } }, { "kind": "Field", "name": { "kind": "Name", "value": "bid_value" } }, { "kind": "Field", "name": { "kind": "Name", "value": "rank" } }, { "kind": "Field", "name": { "kind": "Name", "value": "time_of_bid" } }, { "kind": "Field", "name": { "kind": "Name", "value": "bidder_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "is_removed" } }, { "kind": "Field", "name": { "kind": "Name", "value": "log_index" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tx_hash" } }] } }] };
var GetReceiptDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetReceipt" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "receipt_metadata_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "excess_settlement_funds" } }] } }] } }] };
var GetReceiptsWithExcessSettlementFundsForUserDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetReceiptsWithExcessSettlementFundsForUser" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "userAddress" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "supportedMinterTypes" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "minter_type_names_enum" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "receipt_metadata" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "user_address" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "userAddress" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "excess_settlement_funds" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_neq" }, "value": { "kind": "StringValue", "value": "0", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "minter" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "supportedMinterTypes" } } }] } }] } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "project_minter_configuration" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "complete" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "auction_end_time" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lt" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }] }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "ReceiptSettlementData" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "ReceiptSettlementData" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "receipt_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "project" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "index" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "featured_token" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "media_url" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "vertical_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vertical" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "display_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "category_name" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_type" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "project_minter_configuration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "extra_minter_details" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "excess_settlement_funds" } }] } }] };
var GetProjectDetailsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProjectDetails" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "projects_metadata_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "ProjectDetails" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "MinterDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "minters_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "description_template" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "MinterConfigurationDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "project_minter_configurations" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "currency_symbol" } }, { "kind": "Field", "name": { "kind": "Name", "value": "currency_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "base_price" } }, { "kind": "Field", "name": { "kind": "Name", "value": "extra_minter_details" } }, { "kind": "Field", "name": { "kind": "Name", "value": "offchain_extra_minter_details" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "MinterDetails" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "ProjectDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "projects_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artist_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artist_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "complete" } }, { "kind": "Field", "name": { "kind": "Name", "value": "start_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "auction_start_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "auction_end_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "aspect_ratio" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "invocations" } }, { "kind": "Field", "name": { "kind": "Name", "value": "max_invocations" } }, { "kind": "Field", "name": { "kind": "Name", "value": "paused" } }, { "kind": "Field", "name": { "kind": "Name", "value": "featured_token" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "media_url" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "default_vertical" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "category" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "hosted" } }] } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_configuration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "MinterConfigurationDetails" } }] } }] } }] };
var GetUserTokensInAllowlistDocumentDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getUserTokensInAllowlistDocument" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "allowedProjectIds" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "userAddressAndVaults" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "tokens_metadata" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "project_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "allowedProjectIds" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "owner_address" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "userAddressAndVaults" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "owner_address" } }] } }] } }] };
var GetTokenDetailsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetTokenDetails" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "tokenId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "tokens_metadata_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "tokenId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "invocation" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "invocation" } }, { "kind": "Field", "name": { "kind": "Name", "value": "live_view_url" } }, { "kind": "Field", "name": { "kind": "Name", "value": "owner_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "project" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }] } }] } }] };
var GetUserBidsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetUserBids" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "userAddress" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "project_ranked_bids" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "args" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "project" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "bidder_address" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "userAddress" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "rank" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "BidDetails" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "BidDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "bids_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "slot_index" } }, { "kind": "Field", "name": { "kind": "Name", "value": "bid_value" } }, { "kind": "Field", "name": { "kind": "Name", "value": "rank" } }, { "kind": "Field", "name": { "kind": "Name", "value": "time_of_bid" } }, { "kind": "Field", "name": { "kind": "Name", "value": "bidder_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "is_removed" } }, { "kind": "Field", "name": { "kind": "Name", "value": "log_index" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tx_hash" } }] } }] };
var GetProjectMinterConfigurationDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProjectMinterConfiguration" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "projects_metadata_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "project_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "user_is_artist" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "user_is_allowlisted" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_filter" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "globally_allowed_minters" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "label" } }, { "kind": "Field", "name": { "kind": "Name", "value": "unversioned_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "version_number" } }] } }] } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_configuration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "currency_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "currency_symbol" } }, { "kind": "FragmentSpread", "name": { "kind": "Name", "value": "ProjectMinterConfigurationDetails" } }] } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "ProjectMinterConfigurationDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "project_minter_configurations" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "project_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "base_price" } }, { "kind": "Field", "name": { "kind": "Name", "value": "currency_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "currency_symbol" } }, { "kind": "Field", "name": { "kind": "Name", "value": "max_invocations" } }, { "kind": "Field", "name": { "kind": "Name", "value": "extra_minter_details" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "project_configuration_schema" } }, { "kind": "Field", "name": { "kind": "Name", "value": "unversioned_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "version_number" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "extra_minter_details" } }] } }] } }] };
var GetProjectMinterConfigurationUpdatesDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProjectMinterConfigurationUpdates" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "projects_metadata_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "minter_configuration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "properties_updated_at" } }] } }] } }] } }] };
var GetProjectsMetadataUpdatesQueryDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProjectsMetadataUpdatesQuery" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "projects_metadata_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "properties_updated_at" } }] } }] } }] };
var GetAllowlistUploadUrlDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetAllowlistUploadUrl" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "getAllowlistUploadUrl" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "projectId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "url" } }, { "kind": "Field", "name": { "kind": "Name", "value": "key" } }] } }] } }] };
var UpdateOffChainExtraMinterDetailsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "UpdateOffChainExtraMinterDetails" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectMinterConfigId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "extraMinterDetails" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_project_minter_configurations_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectMinterConfigId" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_append" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "offchain_extra_minter_details" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "extraMinterDetails" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "offchain_extra_minter_details" } }] } }] } }] };

// src/generated/gql.ts
var documents = {
  "\n  query GetReceipt($id: String!) {\n    receipt_metadata_by_pk(id: $id) {\n      id\n      excess_settlement_funds\n    }\n  }\n": GetReceiptDocument,
  "\n  fragment ReceiptSettlementData on receipt_metadata {\n    id\n    project {\n      id\n      name\n      index\n      contract_address\n      featured_token {\n        media_url\n      }\n      vertical_name\n      vertical {\n        display_name\n        category_name\n      }\n      contract {\n        name\n      }\n    }\n\n    minter {\n      address\n      minter_type\n    }\n\n    project_minter_configuration {\n      extra_minter_details\n    }\n    excess_settlement_funds\n  }\n": ReceiptSettlementDataFragmentDoc,
  '\n    query GetReceiptsWithExcessSettlementFundsForUser(\n      $userAddress: String!\n      $supportedMinterTypes: [minter_type_names_enum!]!\n    ) {\n      receipt_metadata(\n        where: {\n          user_address: { _eq: $userAddress }\n          excess_settlement_funds: { _neq: "0" }\n          minter: { type: { type: { _in: $supportedMinterTypes } } }\n          project_minter_configuration: {\n            _or: [\n              { complete: { _eq: true } }\n              { auction_end_time: { _lt: "now()" } }\n            ]\n          }\n        }\n      ) {\n        ...ReceiptSettlementData\n      }\n    }\n  ': GetReceiptsWithExcessSettlementFundsForUserDocument,
  "\n  fragment ProjectDetails on projects_metadata {\n    id\n    artist_address\n    artist_name\n    complete\n    start_datetime\n    auction_start_time\n    auction_end_time\n    aspect_ratio\n    name\n    invocations\n    max_invocations\n    paused\n\n    featured_token {\n      media_url\n    }\n\n    contract {\n      address\n      contract_type\n\n      default_vertical {\n        category {\n          hosted\n        }\n      }\n    }\n\n    minter_configuration {\n      ...MinterConfigurationDetails\n    }\n  }\n\n  fragment MinterConfigurationDetails on project_minter_configurations {\n    currency_symbol\n    currency_address\n    base_price\n\n    extra_minter_details\n    offchain_extra_minter_details\n\n    minter {\n      ...MinterDetails\n    }\n  }\n\n  fragment MinterDetails on minters_metadata {\n    address\n    minter_type\n    type {\n      description_template\n    }\n  }\n": ProjectDetailsFragmentDoc,
  "\n  query GetProjectDetails($projectId: String!) {\n    projects_metadata_by_pk(id: $projectId) {\n      ...ProjectDetails\n    }\n  }\n": GetProjectDetailsDocument,
  "\n  query getUserTokensInAllowlistDocument(\n    $allowedProjectIds: [String!]!\n    $userAddressAndVaults: [String!]!\n  ) {\n    tokens_metadata(\n      where: {\n        project_id: { _in: $allowedProjectIds }\n        owner_address: { _in: $userAddressAndVaults }\n      }\n    ) {\n      id\n      owner_address\n    }\n  }\n": GetUserTokensInAllowlistDocumentDocument,
  "\n  query GetTokenDetails($tokenId: String!) {\n    tokens_metadata_by_pk(id: $tokenId) {\n      id\n      token_id\n      invocation\n      contract_address\n      invocation\n      live_view_url\n      owner_address\n      project {\n        name\n      }\n    }\n  }\n": GetTokenDetailsDocument,
  "\n  fragment BidDetails on bids_metadata {\n    id\n    slot_index\n    bid_value\n    rank\n    time_of_bid\n    bidder_address\n    is_removed\n    log_index\n    tx_hash\n  }\n": BidDetailsFragmentDoc,
  "\n  query GetUserBids($projectId: String!, $userAddress: String!) {\n    project_ranked_bids(\n      args: { project: $projectId }\n      where: { bidder_address: { _eq: $userAddress } }\n      order_by: { rank: asc }\n    ) {\n      ...BidDetails\n    }\n  }\n": GetUserBidsDocument,
  "\n    query GetProjectMinterConfiguration($projectId: String!) {\n      projects_metadata_by_pk(id: $projectId) {\n        project_id\n        user_is_artist\n\n        contract {\n          user_is_allowlisted\n          minter_filter {\n            type\n            address\n            globally_allowed_minters {\n              address\n              minter_type\n              type {\n                label\n                unversioned_type\n                version_number\n              }\n            }\n          }\n        }\n        minter_configuration {\n          currency_address\n          currency_symbol\n          ...ProjectMinterConfigurationDetails\n        }\n      }\n    }\n\n    fragment ProjectMinterConfigurationDetails on project_minter_configurations {\n      id\n      project_id\n      base_price\n      currency_address\n      currency_symbol\n      max_invocations\n      extra_minter_details\n      minter {\n        address\n        minter_type\n        type {\n          project_configuration_schema\n          unversioned_type\n          version_number\n        }\n        extra_minter_details\n      }\n    }\n  ": GetProjectMinterConfigurationDocument,
  "\n    query GetProjectMinterConfigurationUpdates($projectId: String!) {\n      projects_metadata_by_pk(id: $projectId) {\n        minter_configuration {\n          properties_updated_at\n        }\n      }\n    }\n  ": GetProjectMinterConfigurationUpdatesDocument,
  "\n  query GetProjectsMetadataUpdatesQuery($projectId: String!) {\n    projects_metadata_by_pk(id: $projectId) {\n      properties_updated_at\n    }\n  }\n": GetProjectsMetadataUpdatesQueryDocument,
  "\n  query GetAllowlistUploadUrl($projectId: String!) {\n    getAllowlistUploadUrl(projectId: $projectId) {\n      url\n      key\n    }\n  }\n": GetAllowlistUploadUrlDocument,
  "\n    mutation UpdateOffChainExtraMinterDetails(\n      $projectMinterConfigId: String!\n      $extraMinterDetails: jsonb!\n    ) {\n      update_project_minter_configurations_by_pk(\n        pk_columns: { id: $projectMinterConfigId }\n        _append: { offchain_extra_minter_details: $extraMinterDetails }\n      ) {\n        offchain_extra_minter_details\n      }\n    }\n  ": UpdateOffChainExtraMinterDetailsDocument
};
function graphql(source) {
  var _a;
  return (_a = documents[source]) != null ? _a : {};
}

// src/machines/excess-settlement-funds-manager-machine/receipt-polling-machine.ts
var import_xstate8 = require("xstate");

// src/machines/utils.ts
var import_viem6 = require("viem");

// src/machines/project-sale-manager-machine/utils.ts
var import_xstate6 = require("xstate");

// src/machines/project-sale-manager-machine/index.ts
var import_xstate5 = require("xstate");

// src/machines/project-sale-manager-machine/live-sale-data-polling-machine.ts
var import_xstate = require("xstate");
var import_viem = require("viem");

// abis/iSharedMinterV0Abi.ts
var iSharedMinterV0Abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "getPriceInfo",
    outputs: [
      {
        internalType: "bool",
        name: "isConfigured",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "tokenPriceInWei",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "currencySymbol",
        type: "string"
      },
      {
        internalType: "address",
        name: "currencyAddress",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "maxInvocations",
        type: "uint24"
      }
    ],
    name: "manuallyLimitProjectMaxInvocations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "minterFilterAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "minterType",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "syncProjectMaxInvocationsToCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// abis/iGenArt721CoreContractV3BaseAbi.ts
var iGenArt721CoreContractV3BaseAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      }
    ],
    name: "AcceptedArtistAddressesAndSplits",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_currentMinter",
        type: "address"
      }
    ],
    name: "MinterUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "_field",
        type: "bytes32"
      }
    ],
    name: "PlatformUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "_update",
        type: "bytes32"
      }
    ],
    name: "ProjectUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "_artistAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "_additionalPayeePrimarySales",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_additionalPayeePrimarySalesPercentage",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "_additionalPayeeSecondarySales",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_additionalPayeeSecondarySalesPercentage",
        type: "uint256"
      }
    ],
    name: "ProposedArtistAddressesAndSplits",
    type: "event"
  },
  {
    inputs: [],
    name: "admin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sender",
        type: "address"
      },
      {
        internalType: "address",
        name: "_contract",
        type: "address"
      },
      {
        internalType: "bytes4",
        name: "_selector",
        type: "bytes4"
      }
    ],
    name: "adminACLAllowed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "adminACLContract",
    outputs: [
      {
        internalType: "contract IAdminACLV0",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "coreType",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "coreVersion",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getRoyalties",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "minter",
        type: "address"
      }
    ],
    name: "isMintWhitelisted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_by",
        type: "address"
      }
    ],
    name: "mint_Ecf",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "nextProjectId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      }
    ],
    name: "projectDetails",
    outputs: [
      {
        internalType: "string",
        name: "projectName",
        type: "string"
      },
      {
        internalType: "string",
        name: "artist",
        type: "string"
      },
      {
        internalType: "string",
        name: "description",
        type: "string"
      },
      {
        internalType: "string",
        name: "website",
        type: "string"
      },
      {
        internalType: "string",
        name: "license",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      }
    ],
    name: "projectIdToAdditionalPayeePrimarySales",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      }
    ],
    name: "projectIdToAdditionalPayeePrimarySalesPercentage",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      }
    ],
    name: "projectIdToArtistAddress",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      }
    ],
    name: "projectIdToSecondaryMarketRoyaltyPercentage",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_index",
        type: "uint256"
      }
    ],
    name: "projectScriptByIndex",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      }
    ],
    name: "projectScriptDetails",
    outputs: [
      {
        internalType: "string",
        name: "scriptTypeAndVersion",
        type: "string"
      },
      {
        internalType: "string",
        name: "aspectRatio",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "scriptCount",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      }
    ],
    name: "projectStateData",
    outputs: [
      {
        internalType: "uint256",
        name: "invocations",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "maxInvocations",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "active",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "paused",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "completedTimestamp",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      }
    ],
    name: "projectURIInfo",
    outputs: [
      {
        internalType: "string",
        name: "projectBaseURI",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_hash",
        type: "bytes32"
      }
    ],
    name: "setTokenHash_8PT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "startingProjectId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      }
    ],
    name: "tokenIdToHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenIdToProjectId",
    outputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// abis/minterRAMV0Abi.ts
var minterRAMV0Abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "minterFilter",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "auctionBufferSeconds",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxAuctionExtraSeconds",
        type: "uint256"
      }
    ],
    name: "AuctionBufferTimeParamsUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestampStart",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestampEnd",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "basePrice",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "allowExtraTime",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "adminArtistOnlyMintPeriodIfSellout",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "numTokensInAuction",
        type: "uint256"
      }
    ],
    name: "AuctionConfigUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestampEnd",
        type: "uint256"
      }
    ],
    name: "AuctionTimestampEndUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "slotIndex",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bidId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "bidder",
        type: "address"
      }
    ],
    name: "BidCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bidId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "BidMinted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bidId",
        type: "uint256"
      }
    ],
    name: "BidRefunded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bidId",
        type: "uint256"
      }
    ],
    name: "BidRemoved",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bidId",
        type: "uint256"
      }
    ],
    name: "BidSettled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bidId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newSlotIndex",
        type: "uint256"
      }
    ],
    name: "BidToppedUp",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "key",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "value",
        type: "bool"
      }
    ],
    name: "ConfigValueSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum RAMLib.AdminMintingConstraint",
        name: "adminMintingConstraint",
        type: "uint8"
      }
    ],
    name: "ContractConfigUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "minAuctionDurationSeconds",
        type: "uint256"
      }
    ],
    name: "MinAuctionDurationSecondsUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint24",
        name: "refundGasLimit",
        type: "uint24"
      }
    ],
    name: "MinterRefundGasLimitUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "numSlots",
        type: "uint256"
      }
    ],
    name: "NumSlotsUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "numTokensInAuction",
        type: "uint256"
      }
    ],
    name: "NumTokensInAuctionUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxInvocations",
        type: "uint256"
      }
    ],
    name: "ProjectMaxInvocationsLimitUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "TokenPurchased",
    type: "event"
  },
  {
    inputs: [],
    name: "MIN_AUCTION_DURATION_SECONDS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint8",
        name: "emergencyHoursToAdd",
        type: "uint8"
      }
    ],
    name: "adminAddEmergencyAuctionHours",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "numTokensToMint",
        type: "uint24"
      }
    ],
    name: "adminArtistAutoMintTokensToWinners",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint32[]",
        name: "bidIds",
        type: "uint32[]"
      }
    ],
    name: "adminArtistDirectMintTokensToWinners",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint32[]",
        name: "bidIds",
        type: "uint32[]"
      }
    ],
    name: "adminArtistDirectRefundWinners",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "numBidsToRefund",
        type: "uint24"
      }
    ],
    name: "adminAutoRefundWinners",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint32[]",
        name: "bidIds",
        type: "uint32[]"
      }
    ],
    name: "collectSettlements",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "contractConfigurationDetails",
    outputs: [
      {
        internalType: "enum RAMLib.AdminMintingConstraint",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "slotIndex",
        type: "uint16"
      }
    ],
    name: "createBid",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "getAuctionDetails",
    outputs: [
      {
        internalType: "uint256",
        name: "auctionTimestampStart",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "auctionTimestampEnd",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "basePrice",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numTokensInAuction",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numBids",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numBidsMintedTokens",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numBidsErrorRefunded",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "minBidSlotIndex",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "allowExtraTime",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "adminArtistOnlyMintPeriodIfSellout",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "revenuesCollected",
        type: "bool"
      },
      {
        internalType: "enum RAMLib.ProjectMinterStates",
        name: "projectMinterState",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "getIsErrorE1",
    outputs: [
      {
        internalType: "bool",
        name: "isError",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "numBidsToRefund",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "getLowestBidValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "getMinimumNextBid",
    outputs: [
      {
        internalType: "uint256",
        name: "minNextBidValueInWei",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "minNextBidSlotIndex",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "getPriceInfo",
    outputs: [
      {
        internalType: "bool",
        name: "isConfigured",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "tokenPriceInWei",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "currencySymbol",
        type: "string"
      },
      {
        internalType: "address",
        name: "currencyAddress",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "getProjectBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "isEngineView",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "maxInvocations",
        type: "uint24"
      }
    ],
    name: "manuallyLimitProjectMaxInvocations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "maxInvocationsProjectConfig",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "maxHasBeenInvoked",
            type: "bool"
          },
          {
            internalType: "uint24",
            name: "maxInvocations",
            type: "uint24"
          }
        ],
        internalType: "struct MaxInvocationsLib.MaxInvocationsProjectConfig",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minterConfigurationDetails",
    outputs: [
      {
        internalType: "uint256",
        name: "minAuctionDurationSeconds",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "auctionBufferSeconds",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "maxAuctionExtraSeconds",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "maxAuctionAdminEmergencyExtensionHours",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "adminArtistOnlyMintTimeSeconds",
        type: "uint256"
      },
      {
        internalType: "uint24",
        name: "minterRefundGasLimit",
        type: "uint24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minterFilterAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minterType",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minterVersion",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "projectMaxHasBeenInvoked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "projectMaxInvocations",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "purchase",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "purchaseTo",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint40",
        name: "auctionTimestampEnd",
        type: "uint40"
      }
    ],
    name: "reduceAuctionLength",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint40",
        name: "auctionTimestampStart",
        type: "uint40"
      },
      {
        internalType: "uint40",
        name: "auctionTimestampEnd",
        type: "uint40"
      },
      {
        internalType: "uint256",
        name: "basePrice",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "allowExtraTime",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "adminArtistOnlyMintPeriodIfSellout",
        type: "bool"
      }
    ],
    name: "setAuctionDetails",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "enum RAMLib.AdminMintingConstraint",
        name: "adminMintingConstraint",
        type: "uint8"
      }
    ],
    name: "setContractConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "slotIndex",
        type: "uint16"
      }
    ],
    name: "slotIndexToBidValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "syncProjectMaxInvocationsToCore",
    outputs: [],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint32",
        name: "bidId",
        type: "uint32"
      },
      {
        internalType: "uint16",
        name: "newSlotIndex",
        type: "uint16"
      }
    ],
    name: "topUpBid",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint24",
        name: "minterRefundGasLimit",
        type: "uint24"
      }
    ],
    name: "updateRefundGasLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint32[]",
        name: "bidIds",
        type: "uint32[]"
      }
    ],
    name: "winnerDirectMintTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint32[]",
        name: "bidIds",
        type: "uint32[]"
      }
    ],
    name: "winnerDirectRefund",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "withdrawArtistAndAdminRevenues",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/machines/project-sale-manager-machine/live-sale-data-polling-machine.ts
var POLLING_DELAY = 1e4;
var liveSaleDataPollingMachine = (0, import_xstate.setup)({
  types: {
    input: {},
    context: {},
    events: {}
  },
  actors: {
    fetchLiveSaleData: (0, import_xstate.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input: { project, artblocksClient }
      }) {
        var _a;
        const publicClient = artblocksClient.getPublicClient();
        if (!publicClient) {
          throw new Error("Public client is unavailable");
        }
        if (!((_a = project.minter_configuration) == null ? void 0 : _a.minter)) {
          throw new Error("Project has no minter configured");
        }
        const projectIndex = BigInt(project.id.split("-")[1]);
        const minterContract = (0, import_viem.getContract)({
          address: project.minter_configuration.minter.address,
          abi: iSharedMinterV0Abi,
          client: publicClient
        });
        const coreContract = (0, import_viem.getContract)({
          address: project.contract.address,
          abi: iGenArt721CoreContractV3BaseAbi,
          client: publicClient
        });
        const [priceInfo, projectStateData] = yield Promise.all([
          minterContract.read.getPriceInfo([
            projectIndex,
            coreContract.address
          ]),
          coreContract.read.projectStateData([projectIndex])
        ]);
        const [isConfigured, tokenPriceInWei] = priceInfo;
        const [
          invocations,
          maxInvocations,
          active,
          paused,
          completedTimestamp
        ] = projectStateData;
        const liveSaleData = {
          tokenPriceInWei,
          invocations,
          maxInvocations,
          active,
          paused,
          completedTimestamp,
          isConfigured
        };
        if (isRAMMinterType(project.minter_configuration.minter.minter_type)) {
          const ramMinterContract = (0, import_viem.getContract)({
            address: project.minter_configuration.minter.address,
            abi: minterRAMV0Abi,
            client: publicClient
          });
          const [
            [
              auctionTimestampStart,
              auctionTimestampEnd,
              basePrice,
              numTokensInAuction,
              numBids,
              numBidsMintedTokens,
              numBidsErrorRefunded,
              minBidSlotIndex,
              allowExtraTime,
              adminArtistOnlyMintPeriodIfSellout,
              revenuesCollected,
              projectMinterState
            ],
            { maxHasBeenInvoked, maxInvocations: ramMaxInvocations }
          ] = yield Promise.all([
            ramMinterContract.read.getAuctionDetails([
              projectIndex,
              coreContract.address
            ]),
            ramMinterContract.read.maxInvocationsProjectConfig([
              projectIndex,
              coreContract.address
            ])
          ]);
          let [minNextBidValue, minNextBidSlotIndex] = [
            tokenPriceInWei,
            BigInt(0)
          ];
          try {
            [minNextBidValue, minNextBidSlotIndex] = yield ramMinterContract.read.getMinimumNextBid([
              projectIndex,
              coreContract.address
            ]);
          } catch (error) {
          }
          liveSaleData.ramMinterAuctionDetails = {
            auctionStartDate: bigintTimestampToDate(auctionTimestampStart),
            auctionEndDate: bigintTimestampToDate(auctionTimestampEnd),
            basePrice,
            numTokensInAuction,
            numBids,
            numBidsMintedTokens,
            numBidsErrorRefunded,
            minBidSlotIndex,
            allowExtraTime,
            adminArtistOnlyMintPeriodIfSellout,
            revenuesCollected,
            projectMinterState: ProjectMinterStateNumberToEnum[projectMinterState],
            minNextBidValue,
            minNextBidSlotIndex,
            maxHasBeenInvoked,
            maxInvocations: BigInt(ramMaxInvocations)
          };
        }
        return liveSaleData;
      })
    )
  },
  actions: {
    assignLiveSaleDataAndSendToParent: (0, import_xstate.enqueueActions)(
      ({ enqueue, self }, { liveSaleData }) => {
        enqueue.assign({
          liveSaleData
        });
        if (self._parent) {
          enqueue.sendTo(self._parent, {
            type: "LIVE_SALE_DATA_FETCHED",
            data: liveSaleData
          });
        }
      }
    ),
    assignErrorMessageFromError: (0, import_xstate.assign)({
      errorMessage: (_, { error }) => getMessageFromError(error)
    }),
    sendErrorMessageToParent: (0, import_xstate.sendParent)(({ context }) => {
      return {
        type: "ERROR",
        data: context.errorMessage
      };
    })
  }
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QBsCWA3MBlAhssAIjgC44AKA9smgHZQCyOAxgBao1gB0AZmMa+ygAZDNjyESOAMQQKHTu3QUA1lzSZc+IqUrVBjAfN782dERvHacCRRSYlUcgNoAGALqu3iUAAcKsVGJHGm8QAA9EABYADgBOTgB2AGYARhcU2LjYgCYUgDYEgBoQAE9EAFZszhdo6KSEhPK88qTsluzIgF9O4vUxLUldWgZmUy5jQ2FRTQlSKTAAJwWKBc4fZBJuFYBbTj6ZqyH9UfZxvknzftnrW3sg53dPUL8A+5CkcMQAWhTs6M4UuVIs0Uq0EnUXJlimUEJVqrUksCXOU0i4CrFur1ppZBlRhgYxpwAO44QKCKRhWCkYhcHDcGkLAAUqJcLgAlFJ9jidHjjoYuCSyXQnh8XmS5KEIghstkEpxYuVMnlctlIa0XEloYgZSlOJFIklWuUEhqUgk2uVuj0QDQKBA4KEuQMeXo6ATTs9-OL3qApT8EnkAUCQWCIVDSt8UjEAalYhqmpE0pEWpiQE7rkc3ScjOdTFMLM6cJ7XsFJYgUtFddE8q1VbkYgbwVqEF88i5ODWK7EEjka0lkXk8qn04deVn+cTSUE6MXvWXYQ1qrLatEZbFIglItlm7l4uvDUlq9FEy42sPsYXMyMJ4tlgtZ295z9WZxsmC8pXk9EXDEUs2MuUAKxIaMSnjWAYYlaQA */
  context: ({ input }) => ({
    project: input.project,
    artblocksClient: input.artblocksClient
  }),
  id: "liveSaleDataPollingMachine",
  initial: "fetchingLiveSaleData",
  states: {
    fetchingLiveSaleData: {
      invoke: {
        src: "fetchLiveSaleData",
        input: ({ context }) => ({
          project: context.project,
          artblocksClient: context.artblocksClient
        }),
        onDone: [
          {
            target: "waiting",
            actions: {
              type: "assignLiveSaleDataAndSendToParent",
              params: ({ event }) => {
                return {
                  liveSaleData: event.output
                };
              }
            }
          }
        ],
        onError: [
          {
            target: "error",
            actions: {
              type: "assignErrorMessageFromError",
              params: ({ event }) => {
                return {
                  error: event.error
                };
              }
            }
          }
        ]
      }
    },
    waiting: {
      on: {
        FORCE_POLLL: {
          target: "fetchingLiveSaleData"
        }
      },
      after: {
        [POLLING_DELAY]: {
          target: "fetchingLiveSaleData"
        }
      }
    },
    error: {
      type: "final",
      entry: "sendErrorMessageToParent"
    }
  }
});

// src/machines/purchase-initiation-machine/index.ts
var import_xstate2 = require("xstate");

// src/machines/purchase-initiation-machine/utils.ts
var import_merkletreejs = __toESM(require("merkletreejs"));
var import_viem2 = require("viem");

// abis/minterSetPriceMerkleV5Abi.ts
var minterSetPriceMerkleV5Abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "minterFilter",
        type: "address"
      },
      {
        internalType: "address",
        name: "delegationRegistryAddress_",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "delegationRegistryAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "getPriceInfo",
    outputs: [
      {
        internalType: "bool",
        name: "isConfigured",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "tokenPriceInWei",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "currencySymbol",
        type: "string"
      },
      {
        internalType: "address",
        name: "currencyAddress",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "address_",
        type: "address"
      }
    ],
    name: "hashAddress",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "isEngineView",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "maxInvocations",
        type: "uint24"
      }
    ],
    name: "manuallyLimitProjectMaxInvocations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "maxInvocationsProjectConfig",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "maxHasBeenInvoked",
            type: "bool"
          },
          {
            internalType: "uint24",
            name: "maxInvocations",
            type: "uint24"
          }
        ],
        internalType: "struct MaxInvocationsLib.MaxInvocationsProjectConfig",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "merkleProjectConfig",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      },
      {
        internalType: "uint24",
        name: "",
        type: "uint24"
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minterFilterAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minterType",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minterVersion",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]"
      },
      {
        internalType: "address",
        name: "address_",
        type: "address"
      }
    ],
    name: "processProofForAddress",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "projectMaxHasBeenInvoked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "projectMaxInvocations",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "projectMaxInvocationsPerAddress",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "address",
        name: "address_",
        type: "address"
      }
    ],
    name: "projectRemainingInvocationsForAddress",
    outputs: [
      {
        internalType: "bool",
        name: "projectLimitsMintInvocationsPerAddress",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "mintInvocationsRemaining",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "address",
        name: "purchaser",
        type: "address"
      }
    ],
    name: "projectUserMintInvocations",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]"
      }
    ],
    name: "purchase",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]"
      }
    ],
    name: "purchaseTo",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]"
      },
      {
        internalType: "address",
        name: "vault",
        type: "address"
      }
    ],
    name: "purchaseTo",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "setPriceProjectConfig",
    outputs: [
      {
        components: [
          {
            internalType: "uint248",
            name: "pricePerToken",
            type: "uint248"
          },
          {
            internalType: "bool",
            name: "priceIsConfigured",
            type: "bool"
          }
        ],
        internalType: "struct SetPriceLib.SetPriceProjectConfig",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "maxInvocationsPerAddress",
        type: "uint24"
      }
    ],
    name: "setProjectInvocationsPerAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "syncProjectMaxInvocationsToCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "root",
        type: "bytes32"
      }
    ],
    name: "updateMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint248",
        name: "pricePerTokenInWei",
        type: "uint248"
      }
    ],
    name: "updatePricePerTokenInWei",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// abis/iSharedMinterSimplePurchaseV0Abi.ts
var iSharedMinterSimplePurchaseV0Abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "purchase",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "purchaseTo",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  }
];

// abis/iSharedMinterHolderV0Abi.ts
var iSharedMinterHolderV0Abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "address",
        name: "ownedNFTAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "ownedNFTTokenId",
        type: "uint256"
      }
    ],
    name: "purchase",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "address",
        name: "ownedNFTAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "ownedNFTTokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "vault",
        type: "address"
      }
    ],
    name: "purchaseTo",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "address",
        name: "ownedNFTAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "ownedNFTTokenId",
        type: "uint256"
      }
    ],
    name: "purchaseTo",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  }
];

// abis/iDelegationRegistryAbi.ts
var iDelegationRegistryAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "vault",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "delegate",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "value",
        type: "bool"
      }
    ],
    name: "DelegateForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "vault",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "delegate",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "contract_",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "value",
        type: "bool"
      }
    ],
    name: "DelegateForContract",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "vault",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "delegate",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "contract_",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "value",
        type: "bool"
      }
    ],
    name: "DelegateForToken",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "vault",
        type: "address"
      }
    ],
    name: "RevokeAllDelegates",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "vault",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "delegate",
        type: "address"
      }
    ],
    name: "RevokeDelegate",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address"
      },
      {
        internalType: "address",
        name: "vault",
        type: "address"
      }
    ],
    name: "checkDelegateForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address"
      },
      {
        internalType: "address",
        name: "vault",
        type: "address"
      },
      {
        internalType: "address",
        name: "contract_",
        type: "address"
      }
    ],
    name: "checkDelegateForContract",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address"
      },
      {
        internalType: "address",
        name: "vault",
        type: "address"
      },
      {
        internalType: "address",
        name: "contract_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "checkDelegateForToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address"
      },
      {
        internalType: "bool",
        name: "value",
        type: "bool"
      }
    ],
    name: "delegateForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address"
      },
      {
        internalType: "address",
        name: "contract_",
        type: "address"
      },
      {
        internalType: "bool",
        name: "value",
        type: "bool"
      }
    ],
    name: "delegateForContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address"
      },
      {
        internalType: "address",
        name: "contract_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "value",
        type: "bool"
      }
    ],
    name: "delegateForToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "vault",
        type: "address"
      }
    ],
    name: "getContractLevelDelegations",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "contract_",
            type: "address"
          },
          {
            internalType: "address",
            name: "delegate",
            type: "address"
          }
        ],
        internalType: "struct IDelegationRegistry.ContractDelegation[]",
        name: "delegations",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "vault",
        type: "address"
      }
    ],
    name: "getDelegatesForAll",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "vault",
        type: "address"
      },
      {
        internalType: "address",
        name: "contract_",
        type: "address"
      }
    ],
    name: "getDelegatesForContract",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "vault",
        type: "address"
      },
      {
        internalType: "address",
        name: "contract_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getDelegatesForToken",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address"
      }
    ],
    name: "getDelegationsByDelegate",
    outputs: [
      {
        components: [
          {
            internalType: "enum IDelegationRegistry.DelegationType",
            name: "type_",
            type: "uint8"
          },
          {
            internalType: "address",
            name: "vault",
            type: "address"
          },
          {
            internalType: "address",
            name: "delegate",
            type: "address"
          },
          {
            internalType: "address",
            name: "contract_",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256"
          }
        ],
        internalType: "struct IDelegationRegistry.DelegationInfo[]",
        name: "",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "vault",
        type: "address"
      }
    ],
    name: "getTokenLevelDelegations",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "contract_",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "delegate",
            type: "address"
          }
        ],
        internalType: "struct IDelegationRegistry.TokenDelegation[]",
        name: "delegations",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "revokeAllDelegates",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address"
      }
    ],
    name: "revokeDelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "vault",
        type: "address"
      }
    ],
    name: "revokeSelf",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/utils/addresses.ts
var DELEGATION_REGISTRY_ADDRESS = "0x00000000000076a84fef008cdabe6409d2fe638b";

// abis/minterSetPriceERC20V5Abi.ts
var minterSetPriceERC20V5Abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "minterFilter",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "checkYourAllowanceOfProjectERC20",
    outputs: [
      {
        internalType: "uint256",
        name: "remaining",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "getPriceInfo",
    outputs: [
      {
        internalType: "bool",
        name: "isConfigured",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "tokenPriceInWei",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "currencySymbol",
        type: "string"
      },
      {
        internalType: "address",
        name: "currencyAddress",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "getYourBalanceOfProjectERC20",
    outputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "isEngineView",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "maxInvocations",
        type: "uint24"
      }
    ],
    name: "manuallyLimitProjectMaxInvocations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "maxInvocationsProjectConfig",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "maxHasBeenInvoked",
            type: "bool"
          },
          {
            internalType: "uint24",
            name: "maxInvocations",
            type: "uint24"
          }
        ],
        internalType: "struct MaxInvocationsLib.MaxInvocationsProjectConfig",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minterFilterAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minterType",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minterVersion",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "projectMaxHasBeenInvoked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "projectMaxInvocations",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "maxPricePerToken",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "currencyAddress",
        type: "address"
      }
    ],
    name: "purchase",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "maxPricePerToken",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "currencyAddress",
        type: "address"
      }
    ],
    name: "purchaseTo",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "setPriceProjectConfig",
    outputs: [
      {
        components: [
          {
            internalType: "uint248",
            name: "pricePerToken",
            type: "uint248"
          },
          {
            internalType: "bool",
            name: "priceIsConfigured",
            type: "bool"
          }
        ],
        internalType: "struct SetPriceLib.SetPriceProjectConfig",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "syncProjectMaxInvocationsToCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "uint248",
        name: "pricePerTokenInWei",
        type: "uint248"
      }
    ],
    name: "updatePricePerTokenInWei",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "string",
        name: "currencySymbol",
        type: "string"
      },
      {
        internalType: "address",
        name: "currencyAddress",
        type: "address"
      }
    ],
    name: "updateProjectCurrencyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/machines/purchase-initiation-machine/utils.ts
var USER_INELIGIBLE_REASONS = {
  NOT_A_TOKEN_HOLDER: "NOT_A_TOKEN_HOLDER",
  NOT_ALLOWLISTED: "NOT_ALLOWLISTED",
  NO_MINTS_REMAINING: "MINT_LIMIT_REACHED"
};
function assertPublicClientAvailable(publicClient) {
  if (!publicClient) {
    throw new Error("Public client unavailable");
  }
}
function assertWalletClientWithAccount(walletClient) {
  if (!(walletClient == null ? void 0 : walletClient.account)) {
    throw new Error("Wallet client not connected");
  }
}
function assertProjectWithValidMinterConfiguration(project) {
  var _a;
  if (!((_a = project.minter_configuration) == null ? void 0 : _a.minter)) {
    throw new Error("Project has no minter configured");
  }
}
function assertLiveSaleData(liveSaleData) {
  if (!liveSaleData) {
    throw new Error("Live sale data not available");
  }
}
var getUserTokensInAllowlistDocument = graphql(
  /* GraphQL */
  `
  query getUserTokensInAllowlistDocument(
    $allowedProjectIds: [String!]!
    $userAddressAndVaults: [String!]!
  ) {
    tokens_metadata(
      where: {
        project_id: { _in: $allowedProjectIds }
        owner_address: { _in: $userAddressAndVaults }
      }
    ) {
      id
      owner_address
    }
  }
`
);
function getHolderMinterUserPurchaseContext(input) {
  return __async(this, null, function* () {
    var _a, _b;
    const { project, artblocksClient } = input;
    const walletClient = artblocksClient.getWalletClient();
    const publicClient = artblocksClient.getPublicClient();
    assertPublicClientAvailable(publicClient);
    assertWalletClientWithAccount(walletClient);
    assertProjectWithValidMinterConfiguration(project);
    if (!isHolderMinterType((_b = (_a = project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type)) {
      throw new Error("Project is not a token gated minter");
    }
    const allowedProjectIds = project.minter_configuration.extra_minter_details.allowlistedAddressAndProjectId;
    if (!allowedProjectIds) {
      throw new Error("No projects have been allowed for this token gated sale");
    }
    const userVaults = (yield getDelegateVaultsForAccount(
      walletClient.account.address,
      publicClient
    )).map((vault) => vault.toLowerCase());
    const userAddressAndVaults = [
      walletClient.account.address.toLowerCase(),
      ...userVaults
    ];
    const userTokensRes = yield artblocksClient.graphqlRequest(
      getUserTokensInAllowlistDocument,
      {
        allowedProjectIds,
        userAddressAndVaults
      }
    );
    if (userTokensRes.tokens_metadata.length === 0) {
      return {
        isEligible: false,
        ineligibilityReason: USER_INELIGIBLE_REASONS.NOT_A_TOKEN_HOLDER
      };
    }
    const userToken = userTokensRes.tokens_metadata.find(
      (token) => token.owner_address.toLowerCase() === walletClient.account.address.toLowerCase()
    );
    if (userToken) {
      return {
        isEligible: true,
        additionalPurchaseData: {
          allowedTokenId: userToken.id
        }
      };
    }
    const userVaultToken = userTokensRes.tokens_metadata[0];
    const vaultAddress = userVaultToken.owner_address;
    return {
      isEligible: true,
      additionalPurchaseData: {
        allowedTokenId: userVaultToken.id,
        vaultAddress
      }
    };
  });
}
function getDelegateVaultsForAccount(account, publicClient) {
  return __async(this, null, function* () {
    const contract = (0, import_viem2.getContract)({
      abi: iDelegationRegistryAbi,
      address: DELEGATION_REGISTRY_ADDRESS,
      client: publicClient
    });
    const vaults = yield contract.read.getDelegationsByDelegate([account]);
    return vaults.map((vault) => vault.vault);
  });
}
function initiateHolderMinterPurchase(input) {
  return __async(this, null, function* () {
    var _a, _b, _c, _d, _e, _f;
    const {
      artblocksClient,
      project,
      projectSaleManagerMachine: projectSaleManagerMachine2,
      additionalPurchaseData
    } = input;
    const walletClient = artblocksClient.getWalletClient();
    const publicClient = artblocksClient.getPublicClient();
    const liveSaleData = projectSaleManagerMachine2.getSnapshot().context.liveSaleData;
    assertPublicClientAvailable(publicClient);
    assertWalletClientWithAccount(walletClient);
    assertProjectWithValidMinterConfiguration(project);
    assertLiveSaleData(liveSaleData);
    if (!isHolderMinterType((_b = (_a = project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type)) {
      throw new Error("Project is not a token gated minter");
    }
    if (!(additionalPurchaseData == null ? void 0 : additionalPurchaseData.allowedTokenId)) {
      throw new Error("User has no allowed token for this project");
    }
    const [tokenCoreContractAddress, tokenId] = additionalPurchaseData.allowedTokenId.split("-");
    const { projectIndex, coreContractAddress } = getCoreContractAddressAndProjectIndexFromProjectId(project.id);
    const minterContract = (0, import_viem2.getContract)({
      address: (_c = project.minter_configuration) == null ? void 0 : _c.minter.address,
      abi: iSharedMinterHolderV0Abi,
      client: {
        public: publicClient,
        wallet: walletClient
      }
    });
    if (input.purchaseToAddress || ((_d = input.additionalPurchaseData) == null ? void 0 : _d.vaultAddress)) {
      const { request: request2 } = yield minterContract.simulate.purchaseTo(
        [
          input.purchaseToAddress || walletClient.account.address,
          projectIndex,
          coreContractAddress,
          tokenCoreContractAddress,
          BigInt(tokenId),
          (_f = (_e = input.additionalPurchaseData) == null ? void 0 : _e.vaultAddress) != null ? _f : import_viem2.zeroAddress
        ],
        {
          value: liveSaleData.tokenPriceInWei,
          account: walletClient.account.address
        }
      );
      const purchaseTransactionHash2 = yield walletClient.writeContract(request2);
      return purchaseTransactionHash2;
    }
    const { request } = yield minterContract.simulate.purchase(
      [
        projectIndex,
        coreContractAddress,
        tokenCoreContractAddress,
        BigInt(tokenId)
      ],
      {
        value: liveSaleData.tokenPriceInWei,
        account: walletClient.account.address
      }
    );
    const purchaseTransactionHash = yield walletClient.writeContract(request);
    return purchaseTransactionHash;
  });
}
function hashAddress(address) {
  return Buffer.from((0, import_viem2.keccak256)(address).slice(2), "hex");
}
function generateUserMerkleProof(addresses, userAddress) {
  const merkleTree = new import_merkletreejs.default(
    addresses.map((addr) => hashAddress(addr)),
    import_viem2.keccak256,
    {
      sortPairs: true
    }
  );
  return merkleTree.getHexProof(hashAddress(userAddress));
}
function getMerkleMinterUserPurchaseContext(input) {
  return __async(this, null, function* () {
    var _a, _b, _c;
    const { project, artblocksClient } = input;
    const walletClient = artblocksClient.getWalletClient();
    const publicClient = artblocksClient.getPublicClient();
    assertPublicClientAvailable(publicClient);
    assertWalletClientWithAccount(walletClient);
    assertProjectWithValidMinterConfiguration(project);
    if (!isMerkleMinterType((_b = (_a = project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type)) {
      throw new Error("Project is not an allowlist minter");
    }
    const allowlistedAddressesUrl = project.minter_configuration.offchain_extra_minter_details.allowlistedAddressesLink;
    if (!allowlistedAddressesUrl) {
      throw new Error("No allowlist has been configured for this project");
    }
    const { projectIndex, coreContractAddress } = getCoreContractAddressAndProjectIndexFromProjectId(project.id);
    const userVaults = (yield getDelegateVaultsForAccount(
      walletClient.account.address,
      publicClient
    )).map((vault) => vault.toLowerCase());
    const userAddressAndVaults = [
      walletClient.account.address.toLowerCase(),
      ...userVaults
    ];
    try {
      const allowlistedAddressesRes = yield fetch(allowlistedAddressesUrl);
      const allowlistedAddresses = yield allowlistedAddressesRes.json();
      const allowlistedUserAddressAndVaults = allowlistedAddresses == null ? void 0 : allowlistedAddresses.filter(
        (address) => userAddressAndVaults.includes(address.toLowerCase())
      );
      if (!allowlistedUserAddressAndVaults || allowlistedUserAddressAndVaults.length === 0) {
        return {
          isEligible: false,
          ineligibilityReason: USER_INELIGIBLE_REASONS.NOT_ALLOWLISTED
        };
      }
      const minterContract = (0, import_viem2.getContract)({
        address: project.minter_configuration.minter.address,
        abi: minterSetPriceMerkleV5Abi,
        client: {
          public: publicClient,
          wallet: walletClient
        }
      });
      const remainingInvocationsPromises = allowlistedUserAddressAndVaults.map(
        (address) => __async(this, null, function* () {
          const remainingInvocations = yield minterContract.read.projectRemainingInvocationsForAddress([
            projectIndex,
            coreContractAddress,
            address
          ]);
          return [address, ...remainingInvocations];
        })
      );
      const remainingInvocationsResults = yield Promise.all(
        remainingInvocationsPromises
      );
      const hasRemainingMints = remainingInvocationsResults.some(
        ([, projectLimitsMintInvocationsPerAddress2, remaining]) => !projectLimitsMintInvocationsPerAddress2 || remaining > BigInt(0)
      );
      const projectLimitsMintInvocationsPerAddress = remainingInvocationsResults.some(
        ([, projectLimitsMintInvocationsPerAddress2]) => projectLimitsMintInvocationsPerAddress2
      );
      const remainingMints = !projectLimitsMintInvocationsPerAddress ? null : remainingInvocationsResults.reduce((acc, [, , remaining]) => {
        return acc + remaining;
      }, BigInt(0));
      if (!hasRemainingMints) {
        return {
          isEligible: false,
          ineligibilityReason: USER_INELIGIBLE_REASONS.NO_MINTS_REMAINING,
          additionalPurchaseData: {
            allowlist: allowlistedAddresses,
            userAllowlistAddresses: allowlistedUserAddressAndVaults,
            remainingMints
          }
        };
      }
      const userHasRemainingMints = remainingInvocationsResults.find(
        ([address, projectLimitsMintInvocationsPerAddress2, remaining]) => {
          return address.toLowerCase() === walletClient.account.address.toLowerCase() && (!projectLimitsMintInvocationsPerAddress2 || remaining > BigInt(0));
        }
      );
      if (userHasRemainingMints) {
        return {
          isEligible: true,
          additionalPurchaseData: {
            allowlist: allowlistedAddresses,
            userAllowlistAddresses: allowlistedUserAddressAndVaults,
            remainingMints
          }
        };
      }
      const firstVaultWithRemainingMints = (_c = remainingInvocationsResults.find(
        ([, projectLimitsMintInvocationsPerAddress2, remaining]) => {
          return !projectLimitsMintInvocationsPerAddress2 || remaining > BigInt(0);
        }
      )) == null ? void 0 : _c[0];
      return {
        isEligible: true,
        additionalPurchaseData: {
          allowlist: allowlistedAddresses,
          userAllowlistAddresses: allowlistedUserAddressAndVaults,
          vaultAddress: firstVaultWithRemainingMints,
          remainingMints
        }
      };
    } catch (e) {
      throw new Error(
        "Something went wrong while attempting to check your eligibility for purchase of this project. Please try again later."
      );
    }
  });
}
function initiateMerkleMinterPurchase(input) {
  return __async(this, null, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const {
      artblocksClient,
      project,
      projectSaleManagerMachine: projectSaleManagerMachine2,
      additionalPurchaseData
    } = input;
    const walletClient = artblocksClient.getWalletClient();
    const publicClient = artblocksClient.getPublicClient();
    const liveSaleData = projectSaleManagerMachine2.getSnapshot().context.liveSaleData;
    assertPublicClientAvailable(publicClient);
    assertWalletClientWithAccount(walletClient);
    assertProjectWithValidMinterConfiguration(project);
    assertLiveSaleData(liveSaleData);
    if (!isMerkleMinterType((_b = (_a = project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type)) {
      throw new Error("Project is not an allowlist minter");
    }
    if (!project.minter_configuration.extra_minter_details.merkleRoot) {
      throw new Error("Project has no merkle root configured");
    }
    if (!(additionalPurchaseData == null ? void 0 : additionalPurchaseData.allowlist)) {
      throw new Error("No allowlist has been configured for this project");
    }
    const { projectIndex, coreContractAddress } = getCoreContractAddressAndProjectIndexFromProjectId(project.id);
    const minterContract = (0, import_viem2.getContract)({
      address: (_c = project.minter_configuration) == null ? void 0 : _c.minter.address,
      abi: minterSetPriceMerkleV5Abi,
      client: {
        public: publicClient,
        wallet: walletClient
      }
    });
    const merkleProof = generateUserMerkleProof(
      additionalPurchaseData.allowlist,
      (_d = additionalPurchaseData.vaultAddress) != null ? _d : walletClient.account.address
    );
    if (input.purchaseToAddress || ((_e = input.additionalPurchaseData) == null ? void 0 : _e.vaultAddress)) {
      const { request: request2 } = yield minterContract.simulate.purchaseTo(
        [
          (_f = input.purchaseToAddress) != null ? _f : walletClient.account.address,
          projectIndex,
          coreContractAddress,
          merkleProof,
          (_h = (_g = input.additionalPurchaseData) == null ? void 0 : _g.vaultAddress) != null ? _h : import_viem2.zeroAddress
        ],
        {
          value: liveSaleData.tokenPriceInWei,
          account: walletClient.account.address
        }
      );
      const purchaseTransactionHash2 = yield walletClient.writeContract(request2);
      return purchaseTransactionHash2;
    }
    const { request } = yield minterContract.simulate.purchase(
      [projectIndex, coreContractAddress, merkleProof],
      {
        value: liveSaleData.tokenPriceInWei,
        account: walletClient.account.address
      }
    );
    const purchaseTransactionHash = yield walletClient.writeContract(request);
    return purchaseTransactionHash;
  });
}
function checkERC20Allowance(input) {
  return __async(this, null, function* () {
    var _a, _b;
    const { artblocksClient, project } = input;
    const publicClient = artblocksClient.getPublicClient();
    const walletClient = artblocksClient.getWalletClient();
    assertPublicClientAvailable(publicClient);
    assertWalletClientWithAccount(walletClient);
    assertProjectWithValidMinterConfiguration(project);
    if (!isERC20MinterType((_b = (_a = project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type)) {
      throw new Error(
        "Project is not configured to allow payment in ERC-20 tokens"
      );
    }
    const erc20Contract = (0, import_viem2.getContract)({
      abi: import_viem2.erc20Abi,
      address: project.minter_configuration.currency_address,
      client: publicClient
    });
    const allowance = yield erc20Contract.read.allowance([
      walletClient.account.address,
      project.minter_configuration.minter.address
    ]);
    return allowance;
  });
}
function getERC20Decimals(input) {
  return __async(this, null, function* () {
    const { artblocksClient, project } = input;
    const publicClient = artblocksClient.getPublicClient();
    assertProjectWithValidMinterConfiguration(project);
    assertPublicClientAvailable(publicClient);
    const erc20Contract = (0, import_viem2.getContract)({
      abi: import_viem2.erc20Abi,
      address: project.minter_configuration.currency_address,
      client: publicClient
    });
    const decimals = yield erc20Contract.read.decimals();
    return decimals;
  });
}
function initiateERC20AllowanceApproval(input) {
  return __async(this, null, function* () {
    var _a, _b;
    const { artblocksClient, project, erc20ApprovalAmount } = input;
    const walletClient = artblocksClient.getWalletClient();
    const publicClient = artblocksClient.getPublicClient();
    assertPublicClientAvailable(publicClient);
    assertWalletClientWithAccount(walletClient);
    assertProjectWithValidMinterConfiguration(project);
    if (!isERC20MinterType((_b = (_a = project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type)) {
      throw new Error(
        "Project is not configured to allow payment in ERC-20 tokens"
      );
    }
    if (!erc20ApprovalAmount) {
      throw new Error("No ERC-20 approval amount provided");
    }
    const erc20Contract = (0, import_viem2.getContract)({
      abi: import_viem2.erc20Abi,
      address: project.minter_configuration.currency_address,
      client: publicClient
    });
    const { request } = yield erc20Contract.simulate.approve(
      [project.minter_configuration.minter.address, erc20ApprovalAmount],
      {
        account: walletClient.account.address
      }
    );
    return walletClient.writeContract(request);
  });
}
function isERC20AllowanceSufficient(project, allowance) {
  var _a, _b, _c, _d;
  if (!isERC20MinterType((_b = (_a = project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type)) {
    return true;
  }
  return (allowance != null ? allowance : BigInt(0)) >= BigInt((_d = (_c = project.minter_configuration) == null ? void 0 : _c.base_price) != null ? _d : Infinity);
}
function initiateERC20Purchase(input) {
  return __async(this, null, function* () {
    var _a, _b;
    const { artblocksClient, project, projectSaleManagerMachine: projectSaleManagerMachine2 } = input;
    const walletClient = artblocksClient.getWalletClient();
    const publicClient = artblocksClient.getPublicClient();
    const liveSaleData = projectSaleManagerMachine2.getSnapshot().context.liveSaleData;
    assertPublicClientAvailable(publicClient);
    assertWalletClientWithAccount(walletClient);
    assertProjectWithValidMinterConfiguration(project);
    assertLiveSaleData(liveSaleData);
    const { projectIndex, coreContractAddress } = getCoreContractAddressAndProjectIndexFromProjectId(project.id);
    const minterContract = (0, import_viem2.getContract)({
      address: (_a = project.minter_configuration) == null ? void 0 : _a.minter.address,
      abi: minterSetPriceERC20V5Abi,
      client: {
        public: publicClient,
        wallet: walletClient
      }
    });
    const currencyAddress = project.minter_configuration.currency_address;
    const basePrice = BigInt((_b = project.minter_configuration.base_price) != null ? _b : 0);
    if (input.purchaseToAddress) {
      const { request: request2 } = yield minterContract.simulate.purchaseTo(
        [
          input.purchaseToAddress,
          projectIndex,
          coreContractAddress,
          basePrice,
          currencyAddress
        ],
        {
          account: walletClient.account.address
        }
      );
      const purchaseTransactionHash2 = yield walletClient.writeContract(request2);
      return purchaseTransactionHash2;
    }
    const { request } = yield minterContract.simulate.purchase(
      [projectIndex, coreContractAddress, basePrice, currencyAddress],
      {
        account: walletClient.account.address
      }
    );
    const purchaseTransactionHash = yield walletClient.writeContract(request);
    return purchaseTransactionHash;
  });
}
function getRAMMinterUserPurchaseContext(input) {
  return __async(this, null, function* () {
    var _a, _b;
    const { artblocksClient, project } = input;
    const walletClient = artblocksClient.getWalletClient();
    const publicClient = artblocksClient.getPublicClient();
    assertPublicClientAvailable(publicClient);
    assertWalletClientWithAccount(walletClient);
    assertProjectWithValidMinterConfiguration(project);
    if (!isRAMMinterType((_b = (_a = project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type)) {
      throw new Error("Project is not a RAM minter");
    }
    const userBids = yield artblocksClient.graphqlRequest(GetUserBidsDocument, {
      projectId: project.id,
      userAddress: walletClient.account.address.toLowerCase()
    });
    return {
      isEligible: true,
      additionalPurchaseData: {
        userBids: userBids.project_ranked_bids
      }
    };
  });
}
function initiateBasePurchase(input) {
  return __async(this, null, function* () {
    var _a;
    const { artblocksClient, project, projectSaleManagerMachine: projectSaleManagerMachine2 } = input;
    const walletClient = artblocksClient.getWalletClient();
    const publicClient = artblocksClient.getPublicClient();
    const liveSaleData = projectSaleManagerMachine2.getSnapshot().context.liveSaleData;
    assertPublicClientAvailable(publicClient);
    assertWalletClientWithAccount(walletClient);
    assertProjectWithValidMinterConfiguration(project);
    assertLiveSaleData(liveSaleData);
    const { projectIndex, coreContractAddress } = getCoreContractAddressAndProjectIndexFromProjectId(project.id);
    const minterContract = (0, import_viem2.getContract)({
      address: (_a = project.minter_configuration) == null ? void 0 : _a.minter.address,
      abi: iSharedMinterSimplePurchaseV0Abi,
      client: {
        public: publicClient,
        wallet: walletClient
      }
    });
    if (input.purchaseToAddress) {
      const { request: request2 } = yield minterContract.simulate.purchaseTo(
        [input.purchaseToAddress, projectIndex, coreContractAddress],
        {
          value: liveSaleData.tokenPriceInWei,
          account: walletClient.account.address
        }
      );
      const purchaseTransactionHash2 = yield walletClient.writeContract(request2);
      return purchaseTransactionHash2;
    }
    const { request } = yield minterContract.simulate.purchase(
      [projectIndex, coreContractAddress],
      {
        value: liveSaleData.tokenPriceInWei,
        account: walletClient.account.address
      }
    );
    const purchaseTransactionHash = yield walletClient.writeContract(request);
    return purchaseTransactionHash;
  });
}

// src/machines/purchase-initiation-machine/index.ts
var purchaseInitiationMachine = (0, import_xstate2.setup)({
  types: {
    input: {},
    context: {},
    events: {},
    emitted: {}
  },
  actors: {
    getUserPurchaseEligibilityAndContext: (0, import_xstate2.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input
      }) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const { artblocksClient, project } = input;
        const publicClient = artblocksClient.getPublicClient();
        const walletClient = artblocksClient.getWalletClient();
        if (!publicClient) {
          throw new Error("Public client unavailable");
        }
        if (!(walletClient == null ? void 0 : walletClient.account)) {
          throw new Error("Wallet client not connected");
        }
        if (isMerkleMinterType((_b = (_a = project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type)) {
          return yield getMerkleMinterUserPurchaseContext(input);
        }
        if (isHolderMinterType((_d = (_c = project.minter_configuration) == null ? void 0 : _c.minter) == null ? void 0 : _d.minter_type)) {
          return yield getHolderMinterUserPurchaseContext(input);
        }
        if (isERC20MinterType((_f = (_e = project.minter_configuration) == null ? void 0 : _e.minter) == null ? void 0 : _f.minter_type)) {
          const [decimals, erc20Allowance] = yield Promise.all([
            getERC20Decimals(input),
            checkERC20Allowance(input)
          ]);
          return {
            isEligible: true,
            additionalPurchaseData: {
              decimals,
              erc20Allowance
            }
          };
        }
        if (isRAMMinterType((_h = (_g = project.minter_configuration) == null ? void 0 : _g.minter) == null ? void 0 : _h.minter_type)) {
          return yield getRAMMinterUserPurchaseContext(input);
        }
        return {
          isEligible: true
        };
      })
    ),
    initiatePurchase: (0, import_xstate2.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input
      }) {
        var _a, _b, _c, _d, _e, _f;
        const { project } = input;
        if (isMerkleMinterType((_b = (_a = project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type)) {
          return yield initiateMerkleMinterPurchase(input);
        }
        if (isHolderMinterType((_d = (_c = project.minter_configuration) == null ? void 0 : _c.minter) == null ? void 0 : _d.minter_type)) {
          return yield initiateHolderMinterPurchase(input);
        }
        if (isERC20MinterType((_f = (_e = project.minter_configuration) == null ? void 0 : _e.minter) == null ? void 0 : _f.minter_type)) {
          return yield initiateERC20Purchase(input);
        }
        return yield initiateBasePurchase(input);
      })
    ),
    checkERC20Allowance: (0, import_xstate2.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input
      }) {
        return yield checkERC20Allowance(input);
      })
    ),
    initiateERC20AllowanceApproval: (0, import_xstate2.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input
      }) {
        return yield initiateERC20AllowanceApproval(input);
      })
    ),
    waitForERC20AllowanceApprovalConfirmation: (0, import_xstate2.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input
      }) {
        const { artblocksClient } = input;
        const publicClient = artblocksClient.getPublicClient();
        if (!publicClient) {
          throw new Error("Public client unavailable");
        }
        if (!input.erc20ApprovalTxHash) {
          throw new Error("ERC20 approval transaction hash not provided");
        }
        yield publicClient.waitForTransactionReceipt({
          hash: input.erc20ApprovalTxHash
        });
      })
    )
  },
  actions: {
    assignPurchaseToAddress: (0, import_xstate2.assign)({
      purchaseToAddress: (_, params) => params.purchaseToAddress
    }),
    assignErrorMessageFromError: (0, import_xstate2.assign)({
      errorMessage: (_, params) => {
        return getMessageFromError(params.error, params.fallbackMessage);
      }
    }),
    assignErrorMessage: (0, import_xstate2.assign)({
      errorMessage: (_, params) => params.errorMessage
    }),
    resetPurchaseContext: (0, import_xstate2.assign)(({ context }) => {
      const updatedArtblocksClient = context.projectSaleManagerMachine.getSnapshot().context.artblocksClient;
      return {
        artblocksClient: updatedArtblocksClient != null ? updatedArtblocksClient : context.artblocksClient,
        additionalPurchaseData: void 0,
        purchaseToAddress: void 0,
        errorMessage: void 0,
        initiatedTxHash: void 0,
        erc20ApprovalAmount: void 0,
        erc20ApprovalTxHash: void 0,
        userIneligibilityReason: void 0
      };
    }),
    sendTransactionHashToPurchaseTrackingManagerMachine: ({ context }, params) => {
      const purchaseTrackingManagerMachine = context.projectSaleManagerMachine.getSnapshot().context.purchaseTrackingManagerMachine;
      if (!purchaseTrackingManagerMachine) {
        return;
      }
      purchaseTrackingManagerMachine.send({
        type: "PURCHASE_INITIATED",
        txHash: params.txHash
      });
    },
    assignAdditionalPurchaseData: (0, import_xstate2.assign)({
      additionalPurchaseData: (_, params) => params.additionalPurchaseData
    }),
    assignUserIneligibilityReason: (0, import_xstate2.assign)({
      userIneligibilityReason: (_, params) => params.userIneligibilityReason
    }),
    assignInitiatedTxHash: (0, import_xstate2.assign)({
      initiatedTxHash: (_, params) => params.txHash
    }),
    assignERC20ApprovalAmount: (0, import_xstate2.assign)({
      erc20ApprovalAmount: (_, params) => params.approvalAmount
    }),
    assignERC20ApprovalTxHash: (0, import_xstate2.assign)({
      erc20ApprovalTxHash: (_, params) => params.txHash
    }),
    emitPurchaseInitiatedEvent: (0, import_xstate2.emit)((_, params) => ({
      type: "purchaseInitiated",
      txHash: params.txHash
    }))
  },
  guards: {
    isUserRejectedError: (_, { error }) => {
      return isUserRejectedError(error);
    },
    isUserEligibleForPurchase: (_, { userPurchaseContext }) => {
      return userPurchaseContext.isEligible;
    },
    isERC20MinterType: ({ context }) => {
      var _a, _b;
      return isERC20MinterType(
        (_b = (_a = context.project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type
      );
    },
    isERC20AllowanceSufficient: ({ context }, { allowance }) => {
      return isERC20AllowanceSufficient(context.project, allowance);
    },
    isERC20AllowanceInsufficient: ({ context }, { allowance }) => {
      return !isERC20AllowanceSufficient(context.project, allowance);
    },
    isSaleStarted: ({ context }) => {
      const project = context.project;
      const liveSaleData = context.projectSaleManagerMachine.getSnapshot().context.liveSaleData;
      const walletClient = context.artblocksClient.getWalletClient();
      if (!liveSaleData || !(walletClient == null ? void 0 : walletClient.account)) {
        return false;
      }
      if (liveSaleData.paused && project.artist_address !== walletClient.account.address.toLowerCase()) {
        return false;
      }
      if (project.auction_start_time) {
        const startDate = new Date(project.auction_start_time);
        if (startDate > /* @__PURE__ */ new Date()) {
          return false;
        }
      }
      return true;
    }
  }
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QAcCuAnAxgCwIazAEkA7ASwBdTdKB7YgWVx1OLADoZzLioBVA9AAUMOfGACiAG1JRSAI1LTyATwCCxCAGE65MAA9yAYgh12LAG40A1uzRY8BEhSq0GTbC3adufAcPtiUjLyihRqGtrEugYIFjSY1KR0ANoADAC6aemIKDSwznQ5IHqIALQAjAAcAMwALGwAbABMteUArKmptQDs3Q2V5QA0IMqIveVs3U1tAJzlTZ21Mw3VAL6rw3aijmSUiXSMzKwcYFwsvmBCIg4S0rIKSuFaOvpGJsdxNmxbN057rocPMdvOd+Jd-NtbsEHmF1M8oq9YsRLAlXFlkuVskgQMg8gViEUSggKn0mmxak0Gg02k1ytUZjTutVhqMEEt6m0KdVqpUmpVUvzatUGutNtcxH8XEk3EcvKcfGCrgECEF7qEVHDItEjJd0DR0N9JNQAGb6gC233FO2c+xlQLlZx4iohN1VIUempeMTiqOl6IyRVx+VchLKtJ6jUqfRmtQplVmUZZiHK5VS1XJacqlRmWZz3KaopxVqIuylB3cnjY6DAuAgygAYvqXWJDIQAHKEAAqhFUnfEAH1BLwAEqaAASqgAyuIsoG8SHsUTSt02t1GrUGssVkK2lVKkmEM010tlm1+k1ugNUjNCz8JaXbYDK9Xaw2m8XWx3u72B0PRxPpwxLFcmDaVQ2JJk2jYdoeRmao6VSak5gPVoZkmLlUnmVMZjgs9b2LSVHwrY5cAAd1wZweHEUcFlUSRJBocjiEwMBVGQZA9XMXBJFUM0aFQKJDFUQRBGHAB5AA1AdqM0BZ+1UAAZBSxIAdVUNtNBnANsSDfFwMpNc+lqGkmlPYz+W6A96QaSZqW6Cleg6HDEPw5USxtAFiPYMiKJ8GTaPoxjcGY1j2M47jCNcYxTDYT5bAIh9PNlNgfMoqB-NSOiGKYli2I4mguMkSLpSRFFbX9YCcXnMDF2TIU11pGZaWzWZpmMlDaTYFomngxCoxjNpKhFDYizc4ry2S1K-JozLApy0L8sK8biEMXV9UNE1zUtMbEulJ8SPItKMqyoKQry8Kit2uhSvicqMlnHTqsKWqECzdNnLaYVeRjPk2gPZpKjYHCzNSDpqj6YaxR2jy9q8lLDum2TZuy4LcrCgqIqula1oNZAjXIU10AtO9rX+WHJoR85jrm1GFou5abt9FJ7sxOdQOe0AiVTcobIWSoenpflELaP6RkQLM1yzBpyhXLNBoM1zIWW-b2EpnhG3QamUbO9HCsiY1SCJ21oo+ZFrHi6GyYm+02DVqANa1060cW7j9cNs1bUZu7Mm0kC9JeloeTYapQamVIWgZWp9zFtlOu63r+m6AahsV34sZV23fPOB2ZpO+bzoxyQ3aNqKcY2gmtpJ9yrbtSs7ZzpG89pgu9boA2S5Kn1vYev2F055MYzXQXswFTCQ6qf6g-KHDalB6Zozg1P7xh63K0uTAAu153OMgT8ux7PtBxHccpy0yrdL74pEG5bpUkaC9lmqUzMIpWoUOn9CerpDdPv5Hml9JmWWuxx16bydnTAqu9hziGnJ2HuVV2YEgDvPWy4MmTVDPDhBob8Y7YPQjSfk2ZTLlFngWEaVdlZwxYDDHgzYCAmzMGbL4FD05UN2rQ4sXs0T3V9gg-2-cED0iftBMO0wGhJxFtMKy2Zg4CgjlSeqcxIajSVqw5K1CyYcLcqtdAepcb40JsTBKK9gGMJoVAOhYAuF+h4efJ6SCBFPxwtBAUX1E40k5AeJOd8BiXnaK0WYwpugAOrkAjOGipRaMhDovR5dDHbVUSY8J7CLGcK7twzIrNHqIPAvmQyUcmo5h5iuKkB4ZigzYLucRrj4w4V5CEyhyUWEeSgTA8QcDeEXxqgI0oPUpjQWliQ7BPULztAPL0nqlTlj826kNVcwTyHGJrhnHGhhoGwPgV0jmV9iQRgwfZNq8zWjcgPAhMk8tlg5jTOHKkDS1E21QAIEgYA7jyEkGADWli1ltI6XYnJL1el0hsquBYhTehNWFChJklSUy1KZCMjc6wRrEBoBAOAgYllhK8mzfhOzekNHDpUjB4MZhMgpAKBo4z4ITGvP0EOiE5hMhvIsy2WLkogidH4YsboYQagiF6cgOLL5LmmJyIln0k5kr5pSmO3j7481nsSlYoM7lJLhi+OsnzixCu6XirCaFmgpmvKuT6IsvG8i6p9a8cYZa33KKq5ZcMppU1zjTHWLseJ8QEoK7JuKlxVAmPBIUpLdyxj5KUmOqFP6mQTHMJqJCHVspts6qirqt4QKWljHV2yiRDRstyHkzRw5TGnqLVk1kuoYTgk1S8CjE1EWSvXfUjt8661dm3d2tps0OJ2dPbkLicxMiqKuXkVlqSVLkahMNMtuT1qSjbUByNwEt0gN23J15DKcj6AGpOPJ35oQOfBOo1IeSYWUc0x16iUmWLXS9YUQpoJ1FPQNGkPMOoTG3XUBCOFBoJpZYky9NsL0uFXb64ViAw3nMOa4qo7VI3GS6tLIJxSLxzvJgu3R+pb0CNjP0WRVIZYdHsp4mO8wuhsF5PSAJBkNwLKhgBpNlZHmXGea8uQ7ytVuWw3qqM9RrWciIauAlQwY5iMqTUKolIz2xmZesIAA */
  id: "purchaseInitiationMachine",
  context: ({ input }) => ({
    artblocksClient: input.artblocksClient,
    project: input.project,
    projectSaleManagerMachine: input.projectSaleManagerMachine
  }),
  initial: "gettingUserPurchaseEligibilityAndContext",
  states: {
    gettingUserPurchaseEligibilityAndContext: {
      invoke: {
        src: "getUserPurchaseEligibilityAndContext",
        input: ({ context }) => ({
          artblocksClient: context.artblocksClient,
          project: context.project,
          projectSaleManagerMachine: context.projectSaleManagerMachine
        }),
        onDone: [
          {
            target: "waitingForStart",
            actions: {
              type: "assignAdditionalPurchaseData",
              params: ({ event }) => {
                return {
                  additionalPurchaseData: event.output.isEligible ? event.output.additionalPurchaseData : void 0
                };
              }
            },
            guard: {
              type: "isUserEligibleForPurchase",
              params: ({ event }) => ({
                userPurchaseContext: event.output
              })
            }
          },
          {
            target: "userIneligibleForPurchase",
            actions: {
              type: "assignUserIneligibilityReason",
              params: ({ event }) => ({
                userIneligibilityReason: !event.output.isEligible ? event.output.ineligibilityReason : void 0
              })
            }
          }
        ],
        onError: {
          target: "error",
          actions: {
            type: "assignErrorMessageFromError",
            params: ({ event }) => ({
              error: event.error
            })
          }
        }
      }
    },
    waitingForStart: {
      always: {
        target: "readyForPurchase",
        guard: "isSaleStarted"
      },
      after: {
        1e3: {
          target: "waitingForStart",
          reenter: true
        }
      },
      on: {
        RESET: {
          target: "gettingUserPurchaseEligibilityAndContext",
          actions: {
            type: "resetPurchaseContext"
          }
        }
      }
    },
    readyForPurchase: {
      on: {
        INITIATE_PURCHASE: [
          {
            target: "initiatingPurchase",
            actions: {
              type: "assignPurchaseToAddress",
              params: ({ event }) => ({
                purchaseToAddress: event.purchaseToAddress
              })
            },
            guard: {
              type: "isERC20AllowanceSufficient",
              params: ({ context }) => {
                var _a;
                return {
                  allowance: (_a = context.additionalPurchaseData) == null ? void 0 : _a.erc20Allowance
                };
              }
            }
          },
          {
            target: "awaitingERC20AllowanceApprovalAmount",
            actions: {
              type: "assignPurchaseToAddress",
              params: ({ event }) => ({
                purchaseToAddress: event.purchaseToAddress
              })
            }
          }
        ],
        RESET: {
          target: "gettingUserPurchaseEligibilityAndContext",
          actions: {
            type: "resetPurchaseContext"
          }
        }
      }
    },
    awaitingERC20AllowanceApprovalAmount: {
      on: {
        APPROVE_ERC20_ALLOWANCE: {
          target: "awaitingERC20AllowanceApprovalInitiation",
          actions: {
            type: "assignERC20ApprovalAmount",
            params: ({ event }) => ({
              approvalAmount: event.amount
            })
          },
          guard: {
            type: "isERC20AllowanceSufficient",
            params: ({ event }) => ({
              allowance: event.amount
            })
          }
        },
        RESET: {
          target: "gettingUserPurchaseEligibilityAndContext",
          actions: {
            type: "resetPurchaseContext"
          }
        }
      }
    },
    awaitingERC20AllowanceApprovalInitiation: {
      invoke: {
        src: "initiateERC20AllowanceApproval",
        input: ({ context }) => ({
          artblocksClient: context.artblocksClient,
          project: context.project,
          erc20ApprovalAmount: context.erc20ApprovalAmount
        }),
        onDone: [
          {
            target: "waitingForERC20AllowanceApprovalConfirmation",
            actions: {
              type: "assignERC20ApprovalTxHash",
              params: ({ event }) => ({
                txHash: event.output
              })
            }
          }
        ],
        onError: [
          {
            target: "readyForPurchase",
            guard: {
              type: "isUserRejectedError",
              params: ({ event }) => ({
                error: event.error
              })
            }
          },
          {
            target: "error",
            actions: {
              type: "assignErrorMessageFromError",
              params: ({ event }) => ({
                error: event.error
              })
            }
          }
        ]
      }
    },
    waitingForERC20AllowanceApprovalConfirmation: {
      invoke: {
        src: "waitForERC20AllowanceApprovalConfirmation",
        input: ({ context }) => ({
          artblocksClient: context.artblocksClient,
          project: context.project,
          erc20ApprovalTxHash: context.erc20ApprovalTxHash
        }),
        onDone: {
          target: "erc20AllowanceApproved"
        },
        onError: {
          target: "error",
          actions: {
            type: "assignErrorMessageFromError",
            params: ({ event }) => ({
              error: event.error
            })
          }
        }
      }
    },
    erc20AllowanceApproved: {
      on: {
        INITIATE_PURCHASE: {
          target: "initiatingPurchase"
        },
        RESET: {
          target: "gettingUserPurchaseEligibilityAndContext"
        }
      }
    },
    initiatingPurchase: {
      invoke: {
        src: "initiatePurchase",
        input: ({ context }) => ({
          artblocksClient: context.artblocksClient,
          project: context.project,
          purchaseToAddress: context.purchaseToAddress,
          projectSaleManagerMachine: context.projectSaleManagerMachine,
          additionalPurchaseData: context.additionalPurchaseData
        }),
        onDone: {
          target: "purchaseInitiated",
          actions: [
            {
              type: "assignInitiatedTxHash",
              params: ({ event }) => ({
                txHash: event.output
              })
            },
            {
              type: "sendTransactionHashToPurchaseTrackingManagerMachine",
              params: ({ event }) => ({
                txHash: event.output
              })
            },
            {
              type: "emitPurchaseInitiatedEvent",
              params: ({ event }) => ({
                txHash: event.output
              })
            }
          ]
        },
        onError: [
          {
            target: "readyForPurchase",
            guard: {
              type: "isUserRejectedError",
              params: ({ event }) => ({
                error: event.error
              })
            }
          },
          {
            target: "error",
            actions: {
              type: "assignErrorMessageFromError",
              params: ({ event }) => {
                return {
                  error: event.error
                };
              }
            }
          }
        ]
      }
    },
    purchaseInitiated: {
      on: {
        RESET: {
          actions: {
            type: "resetPurchaseContext"
          },
          target: "gettingUserPurchaseEligibilityAndContext"
        }
      }
    },
    error: {
      on: {
        RESET: {
          actions: {
            type: "resetPurchaseContext"
          },
          target: "gettingUserPurchaseEligibilityAndContext"
        }
      }
    },
    userIneligibleForPurchase: {
      on: {
        RESET: {
          actions: {
            type: "resetPurchaseContext"
          },
          target: "gettingUserPurchaseEligibilityAndContext"
        }
      }
    }
  }
});

// src/machines/ram-machine/index.ts
var import_viem4 = require("viem");
var import_xstate3 = require("xstate");

// src/machines/ram-machine/utils.ts
var import_viem3 = require("viem");
var SLOTS_PER_PRICE_DOUBLE = BigInt(64);
function slotIndexToBidValue(basePriceEth, slotIndex) {
  const baseWei = (0, import_viem3.parseEther)(basePriceEth);
  const slot = BigInt(slotIndex);
  let slotBidValue = baseWei << slot / SLOTS_PER_PRICE_DOUBLE;
  slotBidValue += slotBidValue * (slot % SLOTS_PER_PRICE_DOUBLE) / SLOTS_PER_PRICE_DOUBLE;
  return slotBidValue;
}
function dbBidIdToOnChainBidId(dbBidId) {
  const splitBidId = dbBidId.split("-");
  const bidId = Number(splitBidId[splitBidId.length - 1]);
  return bidId;
}

// src/utils/trace-transaction.ts
function traceTransaction(publicClient, txHash) {
  return __async(this, null, function* () {
    return yield publicClient.request({
      method: "trace_transaction",
      params: [txHash]
    });
  });
}

// src/machines/ram-machine/index.ts
graphql(
  /* GraphQL */
  `
  fragment BidDetails on bids_metadata {
    id
    slot_index
    bid_value
    rank
    time_of_bid
    bidder_address
    is_removed
    log_index
    tx_hash
  }
`
);
var getUserBidsDocument = graphql(
  /* GraphQL */
  `
  query GetUserBids($projectId: String!, $userAddress: String!) {
    project_ranked_bids(
      args: { project: $projectId }
      where: { bidder_address: { _eq: $userAddress } }
      order_by: { rank: asc }
    ) {
      ...BidDetails
    }
  }
`
);
var MAX_RETRIES = 10;
var ramMachine = (0, import_xstate3.setup)({
  types: {
    input: {},
    context: {},
    events: {}
  },
  actors: {
    fetchUserBids: (0, import_xstate3.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input
      }) {
        const { artblocksClient, project } = input;
        const publicClient = artblocksClient.getPublicClient();
        const walletClient = artblocksClient.getWalletClient();
        if (!publicClient) {
          throw new Error("Public client unavailable");
        }
        if (!(walletClient == null ? void 0 : walletClient.account)) {
          throw new Error("Wallet client not connected");
        }
        const bids = yield artblocksClient.graphqlRequest(getUserBidsDocument, {
          projectId: project.id,
          userAddress: walletClient.account.address.toLowerCase()
        });
        return bids.project_ranked_bids;
      })
    ),
    initiateBidTx: (0, import_xstate3.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input
      }) {
        var _a, _b, _c;
        const { project, artblocksClient } = input;
        const publicClient = artblocksClient.getPublicClient();
        const walletClient = artblocksClient.getWalletClient();
        const { projectIndex, coreContractAddress } = getCoreContractAddressAndProjectIndexFromProjectId(project.id);
        if (!publicClient) {
          throw new Error("Public client unavailable");
        }
        if (!(walletClient == null ? void 0 : walletClient.account)) {
          throw new Error("Wallet client not connected");
        }
        const minterAddress = (_b = (_a = project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.address;
        if (!minterAddress) {
          throw new Error("Minter is not configured for this project");
        }
        if (input.bidSlotIndex == null) {
          throw new Error("Bid slot is required");
        }
        const basePrice = (_c = project.minter_configuration) == null ? void 0 : _c.base_price;
        if (!basePrice) {
          throw new Error("Base price is not configured for this project");
        }
        const minterContract = (0, import_viem4.getContract)({
          abi: minterRAMV0Abi,
          address: minterAddress,
          client: {
            public: publicClient,
            wallet: walletClient
          }
        });
        const value = slotIndexToBidValue(
          (0, import_viem4.formatEther)(BigInt(basePrice)),
          input.bidSlotIndex
        );
        if (input.topUpBidId) {
          const onChainTopUpBidId = dbBidIdToOnChainBidId(input.topUpBidId);
          const topUpBid = input.userBids.find(
            (bid) => bid.id === input.topUpBidId
          );
          if (!topUpBid) {
            throw new Error("Cannot top up non-existant bid");
          }
          const valueDiff = value - BigInt(topUpBid.bid_value);
          const { request: request2 } = yield minterContract.simulate.topUpBid(
            [
              projectIndex,
              coreContractAddress,
              onChainTopUpBidId,
              input.bidSlotIndex
            ],
            {
              value: valueDiff,
              account: walletClient.account.address
            }
          );
          const txHash2 = yield walletClient.writeContract(request2);
          return {
            txHash: txHash2,
            txRequest: request2
          };
        }
        const { request } = yield minterContract.simulate.createBid(
          [projectIndex, coreContractAddress, input.bidSlotIndex],
          {
            value,
            account: walletClient.account.address
          }
        );
        const txHash = yield walletClient.writeContract(request);
        return {
          txHash,
          txRequest: request
        };
      })
    ),
    waitForBidTxConfirmation: (0, import_xstate3.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input
      }) {
        var _a, _b;
        const { artblocksClient, txHash, txRequest } = input;
        const publicClient = artblocksClient.getPublicClient();
        if (!publicClient) {
          throw new Error("Public client unavailable");
        }
        if (!txHash || !txRequest) {
          throw new Error("Transaction hash and request are required");
        }
        const txReceipt = yield publicClient.waitForTransactionReceipt({
          hash: txHash
        });
        if (txReceipt.status === "reverted") {
          try {
            const traceResult = yield traceTransaction(publicClient, txHash);
            throw new import_viem4.ContractFunctionRevertedError({
              abi: minterRAMV0Abi,
              functionName: txRequest.functionName,
              data: (_b = (_a = traceResult == null ? void 0 : traceResult[0]) == null ? void 0 : _a.result) == null ? void 0 : _b.output
            });
          } catch (e) {
            if (e instanceof import_viem4.ContractFunctionRevertedError) {
              throw e;
            }
            if (txRequest.functionName === "createBid") {
              yield publicClient.simulateContract(txRequest);
            }
            if (txRequest.functionName === "topUpBid") {
              yield publicClient.simulateContract(txRequest);
            }
          }
        }
        const events = (0, import_viem4.parseEventLogs)({
          logs: txReceipt.logs,
          abi: minterRAMV0Abi,
          eventName: ["BidCreated", "BidToppedUp"]
        });
        const event = events[0];
        if (!event) {
          throw new Error("No event found");
        }
        return event.args.bidId;
      })
    )
  },
  actions: {
    assignErrorMessageFromError: (0, import_xstate3.assign)({
      errorMessage: (_, params) => {
        return getMessageFromError(params.error, params.fallbackMessage);
      }
    }),
    assignUserBids: (0, import_xstate3.assign)({
      userBids: (_, params) => params.userBids
    }),
    assignBidAction: (0, import_xstate3.assign)({
      bidAction: (_, params) => params.bidAction
    }),
    resetBidAction: (0, import_xstate3.assign)({
      bidAction: void 0
    }),
    assignTopUpBidId: (0, import_xstate3.assign)({
      topUpBidId: (_, params) => params.topUpBidId
    }),
    resetTopUpBidId: (0, import_xstate3.assign)({
      topUpBidId: void 0
    }),
    assignBidSlotIndex: (0, import_xstate3.assign)({
      bidSlotIndex: (_, params) => params.bidSlotIndex
    }),
    assignPendingBidId: (0, import_xstate3.assign)({
      pendingBidId: (_, params) => params.bidId
    }),
    assignErrorMessage: (0, import_xstate3.assign)({
      errorMessage: (_, params) => params.errorMessage
    }),
    resetBidContext: (0, import_xstate3.assign)({
      errorMessage: void 0,
      txHash: void 0,
      txRequest: void 0,
      bidAction: (_, params) => params == null ? void 0 : params.bidAction,
      topUpBidId: void 0,
      bidSlotIndex: void 0,
      pendingBidId: void 0,
      syncedBid: void 0,
      pollingRetries: 0
    }),
    assignInitiatedTxHash: (0, import_xstate3.assign)({
      txHash: (_, params) => params.txHash
    }),
    assignInitiatedTxRequest: (0, import_xstate3.assign)({
      txRequest: (_, params) => params.txRequest
    }),
    incrementPollingRetries: (0, import_xstate3.assign)({
      pollingRetries: ({ context }) => context.pollingRetries + 1
    }),
    assignSyncedBid: (0, import_xstate3.assign)({
      syncedBid: ({ context }, { userBids }) => {
        const bid = userBids.find((bid2) => {
          var _a;
          const splitBidId = bid2.id.split("-");
          const bidId = splitBidId[splitBidId.length - 1];
          return bidId === ((_a = context.pendingBidId) == null ? void 0 : _a.toString());
        });
        return bid;
      }
    })
  },
  guards: {
    isUserRejectedError: (_, { error }) => {
      return isUserRejectedError(error);
    },
    topUpBidSelected: ({ context }) => {
      return Boolean(context.topUpBidId);
    },
    topUpActionAllowed: ({ context }, { bidAction }) => {
      return bidAction === "topUp" && context.userBids.length > 0;
    },
    isBidSynced: ({ context }, { userBids }) => {
      const bid = userBids.find((bid2) => {
        var _a;
        const splitBidId = bid2.id.split("-");
        const bidId = splitBidId[splitBidId.length - 1];
        return bidId === ((_a = context.pendingBidId) == null ? void 0 : _a.toString());
      });
      return Boolean(bid && bid.slot_index === context.bidSlotIndex);
    },
    retriesRemaining: ({ context }) => {
      return context.pollingRetries < MAX_RETRIES;
    },
    maxRetriesReached: ({ context }) => {
      return context.pollingRetries >= MAX_RETRIES;
    },
    isValidBidSlotIndex: ({ context }, { bidSlotIndex }) => {
      var _a, _b, _c;
      const topUpBid = context.topUpBidId ? context.userBids.find((bid) => {
        return bid.id === context.topUpBidId;
      }) : void 0;
      const liveSaleData = context.liveSaleDataPollingMachineRef.getSnapshot().context.liveSaleData;
      const minBidSlotIndex = topUpBid ? Number((_a = topUpBid.slot_index) != null ? _a : 0) + 1 : Number(
        (_c = (_b = liveSaleData == null ? void 0 : liveSaleData.ramMinterAuctionDetails) == null ? void 0 : _b.minNextBidSlotIndex) != null ? _c : 0
      );
      return bidSlotIndex >= minBidSlotIndex;
    },
    isBidActionCreate: ({ context }) => {
      return context.bidAction === "create";
    },
    isBidActionTopUp: ({ context }) => {
      return context.bidAction === "topUp";
    }
  }
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QCcCGBbAQgSwgWVQGMALbAOzADoAzMAFxPKgFVYxkcJYBiCAewqVyANz4BrKmiy4CjQbQakyLNh1ywEIvoVR1sAgNoAGALrGTiUAAc+sbHoGWQAD0QBaAEwA2ACwAOSgBOAEYAVg8-AHYvYK9Ij1CAGhAAT0QfAGZAyh9I4L8-ENyPD0iAXzLkqU5ZJSoFORV2Th5+QS0JSmqZIjqaekbWZvVNMlEdBzJzA2CLJBAbO0mnVwRPUOCjSiMfTL8vffzQg+S0hFDQrYyw3dCMqLujYIqqjBre8nqBpSa1Ll4BFQOpI3j05F9FEwhn8NFoJvopqYDB45tZbPYESt3B4ssFKFkvMdgtcMjtoqdEISAoE-EZwqEfDE7pFAi8QN18B95N8oaoWgD2mNxCDpJzwf1IcpoS1RuNdAjphlUQt0ct5qtPH5dvjCdEYqUnjsKQhNglKHlgoFbpkEhkfGyObVPhLBnz1Nx2Mg+MhKFYADa6aje9BdUFivoNH7SkZw+WGJGmJyLDGOdXua4eK5+DJ3QKBCLRHxJVKIS2RUKUYlGbxGLyZ4IeWIOsNOwSoADuqAxyk4AEFCJMAMLEPjYQhgbiYACSABEAPq9wcAFSnAHkAHJzwcACVXAGUAKLr8xJ1WYtNrTMXSsRHyle4XLwZLzG00+SiNzNPjaBS535uiq2VAdl2eg9rg-ZDiOY4TtO86LiuG5bruh7HrMp5LOeoAaleXiUAcOzhEY+bRMEkTGlqGQfuWZZhAceblJU7ItlywGdt2UBLnwVjMFYnDDqO47cEuq4AApzsw4lwch+5Hie8zJmq2HuJsPjZDSBw4k+gReEyr5GLS+EMhkOaREYkQWXEAHvOKIEcVxPF8bgAkwZOi4ANLyWimGpspax0RWuzBMEuSRPcJk4q+jbZIaObVlqmaRH41lgn0dlgVAfboHwACuZB0Nwe7MJgeBTkuc5wV5Ko+WQWL+cc2yhL+BSbAZd4ZB4xpFI1RY7AUoRatEKXhs66VMFluX5W5g6eYmClnr5LjuE+WwlJm1aEgyIU+FFoSRJQfiWiFz4EQUw1AZQY3gRAvbZXlBWYB5MzKopWFLWsXjmR+PhhFkFweL+Ravj9VF5g2gTmXeZm1udrFCGQGLytdS7OAKQJCp0jpw+QiMZZwKOytocaImYc3eSmtUXsFNLmhEdqEpkkSMhk+kHPhdIGYSEMDdWsPijjehI5luAox6yBej6-qBsGoaAdjCOC3jIvOIT8LxqTL0LZTfk4u+ZkeP40RJbEzJRaU2y1mpBm1hcBl830AvYEL+Oo563q+gGdBBsgIZY-zCtO0rEAE7GkzTOh801XV3hUXapJNStRjXE+r45u+z5JbkeZFqSHj286hACNQ2A++Nyto-DoiYyx4qF2Qxel8jKuhwqCaa1HF6ZhEQTmcctZkrE+nxB+TWW34XcDRk+dtuxGV7ikZCEBXsB0LoIo2Wls9MPPi9Va9i2rPcEMHdmYWhUWFwUUl+L+BcYRmT4taMa8cu2Vvyg70vbRUCva+yxvo135QE-s9DCFM6r3CZgdN8Wk4jHH0iEG85ZAjRBQb4JK082KgW3gvQgLooxun+N-Suwp-6pUAdgj+uD8G8mGFwVWxNphk2quAzuulsh7V-PcYoxEWYlgQBkMKlZ8zjxMlzBkVkmJ+03pQ4B1DIy0JhBXYEZCRoz1kZ-GhUpCGwiFGrEmoDI6sJ1oSKilw7gRG0klci-C+4fjtOPYi5k7RhEwZdIBmiFHaLoa0QEJDq6vxkRxTxPJvEwgYWHJEKIwFKXehEBqxF8i6SSlqbMxowocNKCgnMOY6bJSkTXIJc95GhN+PyN2ktPbe19oUihwSSmSjKTGPRjC24xLeqsUolpzQHGJLSAGv4zbZEtBFGk0QdghTcVdORi8tFNP+BUj20sfaqIutMkJjToz0JburQx5NYmdLMhWLwgQsiiOfLWOIqcLKNWIp9YkA0QhTI8dQoB3BnC-zoMBagXzkAAApLhGCMAASm4NIupxTZlAL3lraOfgmpBHzEWPM1sE76XCPha4hQaQ-UfpIl+ADBAACNcB7hyoQccsAeAACUDyHiXDCjufkfoAyCJkK0A0GxRCBvw2IAQCjXA2N4WkllQhuIqdwWl9LGXGLiY2d8vhHGMxTryiGoMHGCOuOZA2U82RkD4BAOAThwUUHaQfdMAMAh3D+tWUkd46QUTxOFEKYUSiWn2M-ZigTnRePmfAIxByLWXEoNa38tqdhXn0jifC-Vdg6uJAbNxsBUB+jAIOPg6B-T0DAGa7W71PAlGyGZbMHUoiCKSsWM4jMgh5FPodFkJQizPNkX2AcCIXLjlzXVTw1bgqHBCgUUoe19K5ErAUZJ+QgVNgKd69R9luK8X4tBTtAaOkqRiBwqININgZMGfwq0Ww8w6WzADTYZlPUmqwRxCa90u0XjcAyfa1xLR0iampK0nVeW8PNKZQFsQfo6TcY7Z2ys71+RJDeFB2ZuVJx5WcM9q0cwXGzHtA4mQ3F1wbugMuwdVj7LXSaT6Hh8KMhiHWeOTVAiszwpynmXKgV1mbfUxeYG4nPnfJkLluQ9oP2NPE-CIiXGQOIlaJjkK8G+q2f6-D5qEAGwbDkDMg0eNGi-ebJ8SSGQ2wGmKmdhKr3icoEA1jh8DYVnWgyVDfdx76RMsI3SVs6RPnuGJnBszYC4MgCZxASH9qaSeDmGkZEaTGiyNkO8AN5MDU+gcVzVDZkVO8wI44eF2VamIoUYKO1+FajxAyADLJTkkS8G4klEAyUUrgNJlhgaEB3kMvmN9Dxdi6SvnhVJ7VT6mPFeLb0SWY78r7U+RmZ9P3wfhUWpm2qLKbHHRUCoQA */
  id: "ramBidMachine",
  context: ({ input }) => ({
    artblocksClient: input.artblocksClient,
    project: input.project,
    liveSaleDataPollingMachineRef: input.liveSaleDataPollingMachineRef,
    userBids: [],
    pollingRetries: 0
  }),
  initial: "fetchingUserBids",
  states: {
    fetchingUserBids: {
      invoke: {
        src: "fetchUserBids",
        input: ({ context }) => ({
          artblocksClient: context.artblocksClient,
          project: context.project
        }),
        onDone: [
          {
            target: "awaitingBidAmount",
            guard: "isBidActionCreate",
            actions: {
              type: "assignUserBids",
              params: ({ event }) => ({
                userBids: event.output
              })
            }
          },
          {
            target: "awaitingTopUpBidChoice",
            guard: "isBidActionTopUp",
            actions: {
              type: "assignUserBids",
              params: ({ event }) => ({
                userBids: event.output
              })
            }
          },
          {
            target: "awaitingBidActionChoice",
            actions: [
              {
                type: "assignUserBids",
                params: ({ event }) => ({
                  userBids: event.output
                })
              }
            ]
          }
        ],
        onError: {
          target: "error",
          actions: {
            type: "assignErrorMessageFromError",
            params: ({ event }) => ({
              error: event.error
            })
          }
        }
      }
    },
    awaitingBidActionChoice: {
      on: {
        BID_ACTION_CHOSEN: [
          {
            target: "awaitingTopUpBidChoice",
            actions: {
              type: "assignBidAction",
              params: ({ event }) => ({
                bidAction: event.bidAction
              })
            },
            guard: {
              type: "topUpActionAllowed",
              params: ({ event }) => ({
                bidAction: event.bidAction
              })
            }
          },
          {
            target: "awaitingBidAmount"
          }
        ]
      }
    },
    awaitingTopUpBidChoice: {
      description: "The user chooses an existing bid to top up",
      on: {
        TOP_UP_BID_CHOSEN: {
          target: "awaitingBidAmount",
          actions: {
            type: "assignTopUpBidId",
            params: ({ event }) => ({
              topUpBidId: event.bidId
            })
          }
        },
        BACK: {
          target: "awaitingBidActionChoice",
          actions: "resetBidAction"
        }
      }
    },
    awaitingBidAmount: {
      on: {
        SUBMIT_BID: {
          target: "initiatingBidTx",
          actions: {
            type: "assignBidSlotIndex",
            params: ({ event }) => ({
              bidSlotIndex: event.bidSlotIndex
            })
          },
          guard: {
            type: "isValidBidSlotIndex",
            params: ({ event }) => ({
              bidSlotIndex: event.bidSlotIndex
            })
          }
        },
        BACK: [
          {
            target: "awaitingTopUpBidChoice",
            guard: "topUpBidSelected",
            actions: "resetTopUpBidId"
          },
          {
            target: "awaitingBidActionChoice",
            actions: "resetBidAction"
          }
        ]
      }
    },
    initiatingBidTx: {
      invoke: {
        src: "initiateBidTx",
        input: ({ context }) => ({
          artblocksClient: context.artblocksClient,
          project: context.project,
          liveSaleDataPollingMachineRef: context.liveSaleDataPollingMachineRef,
          topUpBidId: context.topUpBidId,
          bidSlotIndex: context.bidSlotIndex,
          userBids: context.userBids
        }),
        onDone: {
          target: "confirmingBidTx",
          actions: [
            {
              type: "assignInitiatedTxHash",
              params: ({ event }) => ({
                txHash: event.output.txHash
              })
            },
            {
              type: "assignInitiatedTxRequest",
              params: ({ event }) => ({
                txRequest: event.output.txRequest
              })
            }
          ]
        },
        onError: [
          {
            target: "awaitingBidAmount",
            guard: {
              type: "isUserRejectedError",
              params: ({ event }) => {
                return {
                  error: event.error
                };
              }
            }
          },
          {
            target: "error",
            actions: {
              type: "assignErrorMessageFromError",
              params: ({ event }) => {
                return {
                  error: event.error
                };
              }
            }
          }
        ]
      }
    },
    confirmingBidTx: {
      invoke: {
        src: "waitForBidTxConfirmation",
        input: ({ context }) => ({
          artblocksClient: context.artblocksClient,
          txHash: context.txHash,
          txRequest: context.txRequest
        }),
        onDone: {
          target: "awaitingSync",
          actions: {
            type: "assignPendingBidId",
            params: ({ event }) => ({
              bidId: Number(event.output)
            })
          }
        },
        onError: {
          target: "error",
          actions: {
            type: "assignErrorMessageFromError",
            params: ({ event }) => {
              return {
                error: event.error
              };
            }
          }
        }
      }
    },
    awaitingSync: {
      initial: "fetchingUserBids",
      onDone: [
        {
          target: "bidSuccess",
          guard: (0, import_xstate3.stateIn)({ awaitingSync: "synced" })
        },
        {
          target: "error",
          guard: (0, import_xstate3.stateIn)({ awaitingSync: "error" })
        }
      ],
      states: {
        fetchingUserBids: {
          invoke: {
            src: "fetchUserBids",
            input: ({ context }) => ({
              artblocksClient: context.artblocksClient,
              project: context.project
            }),
            onDone: [
              {
                target: "synced",
                actions: [
                  {
                    type: "assignUserBids",
                    params: ({ event }) => ({
                      userBids: event.output
                    })
                  },
                  {
                    type: "assignSyncedBid",
                    params({ event }) {
                      return {
                        userBids: event.output
                      };
                    }
                  }
                ],
                guard: {
                  type: "isBidSynced",
                  params: ({ event }) => ({
                    userBids: event.output
                  })
                }
              },
              {
                target: "waiting",
                actions: [
                  {
                    type: "incrementPollingRetries"
                  },
                  {
                    type: "assignUserBids",
                    params: ({ event }) => ({
                      userBids: event.output
                    })
                  }
                ],
                guard: "retriesRemaining"
              },
              {
                target: "error",
                actions: {
                  type: "assignErrorMessage",
                  params: {
                    errorMessage: "Your bid has been submitted but indexing is taking longer than usual."
                  }
                }
              }
            ],
            onError: [
              {
                target: "waiting",
                actions: {
                  type: "incrementPollingRetries"
                },
                guard: "retriesRemaining"
              },
              {
                target: "error",
                actions: {
                  type: "assignErrorMessageFromError",
                  params: ({ event }) => ({
                    error: event.error
                  })
                }
              }
            ]
          }
        },
        waiting: {
          after: {
            5e3: "fetchingUserBids"
          }
        },
        synced: {
          type: "final"
        },
        error: {
          type: "final"
        }
      }
    },
    bidSuccess: {
      on: {
        RESET: {
          actions: {
            type: "resetBidContext",
            params: ({ event }) => ({
              bidAction: event.bidAction
            })
          },
          target: "fetchingUserBids"
        }
      }
    },
    error: {
      on: {
        RESET: {
          actions: {
            type: "resetBidContext"
          },
          target: "fetchingUserBids"
        }
      }
    }
  }
});

// src/machines/post-ram-machine/index.ts
var import_xstate4 = require("xstate");
var postRAMMachine = (0, import_xstate4.setup)({
  types: {
    input: {},
    context: {},
    events: {}
  },
  actors: {
    fetchUserBids: (0, import_xstate4.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input
      }) {
        const { artblocksClient, project } = input;
        const publicClient = artblocksClient.getPublicClient();
        const walletClient = artblocksClient.getWalletClient();
        if (!publicClient) {
          throw new Error("Public client unavailable");
        }
        if (!(walletClient == null ? void 0 : walletClient.account)) {
          throw new Error("Wallet client not connected");
        }
        const bids = yield artblocksClient.graphqlRequest(GetUserBidsDocument, {
          projectId: project.id,
          userAddress: walletClient.account.address.toLowerCase()
        });
        return bids.project_ranked_bids;
      })
    )
  },
  actions: {
    assignErrorMessageFromError: (0, import_xstate4.assign)({
      errorMessage: (_, params) => {
        return getMessageFromError(params.error, params.fallbackMessage);
      }
    }),
    assignUserBids: (0, import_xstate4.assign)({
      userBids: (_, params) => params.userBids
    })
  }
}).createMachine({
  id: "postRAMBidMachine",
  context: ({ input }) => ({
    artblocksClient: input.artblocksClient,
    project: input.project,
    userBids: []
  }),
  initial: "fetchingUserBids",
  states: {
    fetchingUserBids: {
      invoke: {
        src: "fetchUserBids",
        input: ({ context }) => ({
          artblocksClient: context.artblocksClient,
          project: context.project
        }),
        onDone: [
          {
            target: "saleComplete",
            actions: {
              type: "assignUserBids",
              params: ({ event }) => ({
                userBids: event.output
              })
            }
          }
        ],
        onError: {
          target: "error",
          actions: {
            type: "assignErrorMessageFromError",
            params: ({ event }) => ({
              error: event.error
            })
          }
        }
      }
    },
    saleComplete: {},
    error: {
      on: {
        RESET: {
          target: "fetchingUserBids"
        }
      }
    }
  }
});

// src/machines/project-sale-manager-machine/index.ts
var projectSaleManagerMachine = (0, import_xstate5.setup)({
  types: {
    input: {},
    context: {},
    events: {}
  },
  actors: {
    fetchProjectDetails: (0, import_xstate5.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input
      }) {
        const { projectId, artblocksClient } = input;
        if (!projectId) {
          throw new ProjectIneligibleForPrimarySaleError(
            "No Art Blocks project ID provided. Primary sale not available."
          );
        }
        const res = yield artblocksClient.graphqlRequest(
          getProjectDetailsDocument,
          {
            projectId
          }
        );
        const project = res.projects_metadata_by_pk;
        if (!project) {
          throw new Error("Project not found");
        }
        return project;
      })
    ),
    liveSaleDataPollingMachine,
    purchaseInitiationMachine,
    ramMachine,
    postRAMMachine
  },
  actions: {
    assignArtBlocksClient: (0, import_xstate5.assign)({
      artblocksClient: (_, params) => params.artblocksClient
    }),
    assignProject: (0, import_xstate5.assign)({
      project: (_, params) => params.project
    }),
    assignLiveSaleData: (0, import_xstate5.enqueueActions)(
      ({ enqueue }, { liveSaleData }) => {
        enqueue.assign({
          liveSaleData
        });
        if (!liveSaleData.isConfigured) {
          enqueue.assign({
            projectIneligibleReason: "Project is not configured for sale"
          });
        }
      }
    ),
    assignErrorMessageFromError: (0, import_xstate5.assign)({
      errorMessage: (_, params) => {
        return getMessageFromError(params.error, params.fallbackMessage);
      }
    }),
    assignErrorMessage: (0, import_xstate5.assign)({
      errorMessage: (_, params) => params.errorMessage
    }),
    assignProjectIneligibleReason: (0, import_xstate5.assign)({
      projectIneligibleReason: (_, params) => params.projectIneligibleReason
    }),
    spawnLiveSaleDataPollingMachine: (0, import_xstate5.enqueueActions)(
      ({ enqueue, context, system }) => {
        const project = context.project;
        if (!project) {
          console.warn("No project found in context");
          return;
        }
        if (system.get("liveSaleDataPollingMachine")) {
          return;
        }
        enqueue.spawnChild("liveSaleDataPollingMachine", {
          systemId: "liveSaleDataPollingMachine",
          id: "liveSaleDataPollingMachine",
          input: {
            artblocksClient: context.artblocksClient,
            project
          }
        });
      }
    ),
    stopLiveSaleDataPollingMachine: (0, import_xstate5.enqueueActions)(({ enqueue, system }) => {
      if (!system.get("liveSaleDataPollingMachine")) {
        return;
      }
      enqueue.stopChild("liveSaleDataPollingMachine");
    }),
    assignPurchaseTrackingManagerMachine: (0, import_xstate5.assign)({
      purchaseTrackingManagerMachine: (_, params) => params.purchaseTrackingManagerMachine
    }),
    assignContextFromFailedFetchProjectDetails: (0, import_xstate5.enqueueActions)(
      ({ enqueue }, params) => {
        if (params.error instanceof ProjectIneligibleForPrimarySaleError) {
          enqueue.assign({
            projectIneligibleReason: params.error.message
          });
          return;
        }
        enqueue.assign({
          errorMessage: getMessageFromError(params.error)
        });
      }
    ),
    spawnAndAssignPurchaseInitiationMachine: (0, import_xstate5.assign)({
      purchaseInitiationMachine: ({ spawn, context, self }) => {
        if (!context.project) {
          return;
        }
        return spawn("purchaseInitiationMachine", {
          systemId: "purchaseInitiationMachine",
          id: "purchaseInitiationMachine",
          input: {
            artblocksClient: context.artblocksClient,
            project: context.project,
            projectSaleManagerMachine: self
          }
        });
      }
    }),
    stopAndAssignPurchaseInitiationMachine: (0, import_xstate5.enqueueActions)(({ enqueue }) => {
      enqueue.stopChild("purchaseInitiationMachine");
      enqueue.assign({
        purchaseInitiationMachine: void 0
      });
    }),
    spawnAndAssignRamMachine: (0, import_xstate5.assign)({
      ramMachine: ({ spawn, context, system }) => {
        if (!context.project) {
          return;
        }
        const liveSaleDataPollingMachineRef = system.get(
          "liveSaleDataPollingMachine"
        );
        if (!liveSaleDataPollingMachineRef) {
          return;
        }
        return spawn("ramMachine", {
          systemId: "ramMachine",
          id: "ramMachine",
          input: {
            artblocksClient: context.artblocksClient,
            project: context.project,
            liveSaleDataPollingMachineRef
          }
        });
      }
    }),
    stopAndAssignRamMachine: (0, import_xstate5.enqueueActions)(({ enqueue }) => {
      enqueue.stopChild("ramMachine");
      enqueue.assign({
        ramMachine: void 0
      });
    }),
    spawnAndAssignPostRAMMachine: (0, import_xstate5.assign)({
      postRAMMachine: ({ spawn, context }) => {
        if (!context.project) {
          return;
        }
        return spawn("postRAMMachine", {
          systemId: "postRAMMachine",
          id: "postRAMMachine",
          input: {
            artblocksClient: context.artblocksClient,
            project: context.project
          }
        });
      }
    }),
    forceLiveSaleDataPoll: (0, import_xstate5.enqueueActions)(({ system }) => {
      const liveSaleDataPollingMachineRef = system.get(
        "liveSaleDataPollingMachine"
      );
      if (!liveSaleDataPollingMachineRef) {
        return;
      }
      liveSaleDataPollingMachineRef.send({ type: "FORCE_POLLL" });
    })
  },
  guards: {
    isNotPurchasable: ({ context }) => {
      return !isProjectPurchasable(context);
    },
    isPurchasable: ({ context }) => {
      return isProjectPurchasable(context);
    },
    isRAMBiddable: ({ context }) => {
      return isProjectRAMBiddable(context);
    },
    isNotRAMBiddable: ({ context }) => {
      return !isProjectRAMBiddable(context);
    },
    isPostRAM: ({ context }) => {
      return isProjectPostRAM(context);
    },
    isNotPostRAM: ({ context }) => {
      return !isProjectPostRAM(context);
    },
    isProjectComplete: ({ context }) => {
      return isProjectComplete(context.project, context.liveSaleData);
    },
    isProjectIneligibleForPrimarySale: ({ context }) => {
      return isProjectIneligibleForPrimarySale(context);
    },
    isErrorMessageAvailable: ({ context }) => {
      return Boolean(context.errorMessage);
    },
    isPublicClientUnavailable: ({ context }) => {
      return !context.artblocksClient.getPublicClient();
    }
  }
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QAcBOB7AVmAxgFwGUBDAGzAFkiA7ImVSnACwEsqwBiAQQCUAVAfQBCAGQDyAYQDSBfuOEBJAKIA5AQFUACgBFOvRVoDaABgC6iFOljM8zdFXMgAHogCMANgBMADgB0XlwDsAMzeAJwALC4eweEANCAAnojhAKzhPgEB4dluLl4pQQVuAQC+JfFoWLiEpBTUtGD0REysHBpq3OIAEpwEivy83JxS8soA4vzknMqcY4rck8Ndo-2cAGqc8sKcIorGZkggyJbWtvaHzggAtO5BAT4uUSkud55B4aEe8UkIWb4pKQCLjSHneoRSnzKFQw2HwxDIlBodAYLDY7HanR6fQGQxG40WMzmCym3RW-DUMw2Wx2wj2pgcxysNjsDkuNzc4XuXiyHnCxQCbiMRhC30QERSPiMKSMuSMeUCANK5SOMOq8LqSMaKNa7Hm3FE3H2DJOzPOoDZHKCPiC+SMXlCoSygJSX0SiBt6TcXneUoCgM8oSCUJVVThtURDSaLTRCjW-QInFp-B0vE4-AAYopeN19EbDozTiyLogrp8JQLuTLueEPByXKKEB6fF6fc6BR5A8HKrCagj6sjmqiwD4AGZgPDRqAaVX4LREPBEdgQOzD1gAN3QAGth921eH+1rB61R+PJ9PQ3g5wuEOv0Dh52d9nmLEyzqyS4L0tLa4U5W4IkEDb5L4oLhEY3hCqCmQpF2M69hqkbamwJ4TqiU5wVei6NBgqA+MgJDziO6CoAAtnhcHqhGA7RsOY6oaw6EXphN5UBu96mk+9L5iab7Ftcbi5JKAQdmBLg1i63oNlEQQuJKAKhMUjzcl6biwRelEHlGQ4+MwEBkOwz5HDxRbmq4qRGNaoTAo6sotq6PxeukXi5AUdxGFkRjhGpPYaZqWnHrp+kGC4BwvoWZpOGZHgWcEBTekC-41kB7l+DKALAkEbgugJ3l7n2flIauekcAYHihUZr4mZFCBidKlnWQKLhViKboIBEoR+IG-5ZTKHh9blYb5YhR7IYFJVBOVBamu+NWchKjp+hyRhWeB4FSU8PiApynliS8HxKtC6n7gVI1FUF4STcZEWXGJwl+IKIQuIGYlZQEUnvFaNpeHy3hZdkUoDfBVGHjROnFQZKSXZV11mfkDxeO53jeDaLZSQUX4hG4QSfEKCkuIDvnDaDY0GW4UPhTNYmZT4ta+g6vpZVJr3Wp5KTOZ5IScwTx1E9pJMGAE5PTXxYnZDT0qOvK7y8m9rV5AUPiRPkbPgT13jc0N1HaagYBEBACTpsRGgAK6oEwRCwCVXFhcLpkIHy9zPLaCmRLWT2yz8TXhCBaSZUCISq14GsIVrx463rBvEdwRAkQZ1sVRTfHSm4ispIKgRY3yYFuO97ybStmVszWoSeWUypUOgEBwAyFE86HbDGtDM03Mt6TRWC2QeC6CmhA2EL3JlwIdu5DrhHcwfA-5yF0WeGHzkQjeJ3bLd8jTwofJ33f-lJwqyR8tXvHkXg-hPmmFWDZCL7b1VXH1HiSp4nhePaeSRIzrUu4rVne+n-gCfjypdyDRDiDbWut9aG1QCbM2jALZgCvrxO2mQvzejZkCLu-hnI7zuIrIImU367TTkHQBtdNagLDuAyOqBo4kQQVVS4zl0jgj5MUTy+Q8i9zlpzOSMkmqIwegdEMPk67kOQoyPAQxyB0JhggDwLx74Ag9KkGSbNn5SW9ukLIY8Preg5GzU+J1QZAPguIdAJF8LjngdxJufE5EOkVryUI3IHR+ntDnD+AQLKeFVt+RKHYDG82PNhYi0iZp9TZpKdhqQfp8hSA2TxEpVHuSyt1B0ADDrCLIVPHccF5BsBIMwKAzAABGZBIHTmYCRIgqAEjqlCbY9wskIipCeh2FGgFWrH3+HgqIQpAQyyVGUIAA */
  id: "projectSaleManagerMachine",
  context: ({ input }) => ({
    projectId: input.projectId,
    artblocksClient: input.artblocksClient,
    project: input.project
  }),
  initial: "fetchingProjectData",
  on: {
    ART_BLOCKS_CLIENT_UPDATED: [
      {
        actions: [
          {
            type: "assignArtBlocksClient",
            params: ({ event }) => ({
              artblocksClient: event.artblocksClient
            })
          }
        ]
      }
    ],
    PURCHASE_TRACKING_MANAGER_MACHINE_AVAILABLE: {
      actions: {
        type: "assignPurchaseTrackingManagerMachine",
        params: ({ event }) => ({
          purchaseTrackingManagerMachine: event.data
        })
      }
    },
    PURCHASE_TRACKING_MANAGER_MACHINE_UNAVAILABLE: {
      actions: {
        type: "assignPurchaseTrackingManagerMachine",
        params: { purchaseTrackingManagerMachine: void 0 }
      }
    },
    ERROR: {
      actions: {
        type: "assignErrorMessage",
        params: ({ event }) => ({
          errorMessage: event.data
        })
      }
    },
    LIVE_SALE_DATA_FETCHED: {
      actions: {
        type: "assignLiveSaleData",
        params: ({ event }) => ({
          liveSaleData: event.data
        })
      }
    },
    FORCE_LIVE_SALE_DATA_POLL: {
      actions: {
        type: "forceLiveSaleDataPoll"
      }
    }
  },
  states: {
    fetchingProjectData: {
      invoke: {
        src: "fetchProjectDetails",
        input: ({ context }) => ({
          projectId: context.projectId,
          artblocksClient: context.artblocksClient
        }),
        onDone: [
          {
            target: "idle",
            actions: {
              type: "assignProject",
              params: ({ event }) => ({
                project: event.output
              })
            }
          }
        ],
        onError: {
          target: "idle",
          actions: {
            type: "assignContextFromFailedFetchProjectDetails",
            params: ({ event }) => ({
              error: event.error
            })
          }
        }
      }
    },
    idle: {
      description: "The 'idle' state is a waiting state where the machine evaluates the next steps based on the current context. It acts as a decision point, assessing conditions for a sale, errors, project ineligibility, or completion. Transitions from this state are determined by guards that check data availability, project eligibility, and other sale prerequisites. If conditions change, the machine moves to a specific state to handle the situation, such as initiating the sale process, handling errors, or dealing with ineligibility or completion.",
      always: [
        {
          target: "error",
          guard: "isErrorMessageAvailable",
          actions: "stopLiveSaleDataPollingMachine"
        },
        {
          target: "projectIneligibleForPrimarySale",
          guard: "isProjectIneligibleForPrimarySale",
          actions: "stopLiveSaleDataPollingMachine"
        },
        {
          target: "projectSaleComplete",
          guard: "isProjectComplete",
          actions: "stopLiveSaleDataPollingMachine"
        },
        {
          target: "readyForPurchase",
          guard: "isPurchasable"
        },
        {
          target: "readyForRam",
          guard: "isRAMBiddable"
        },
        {
          target: "postRAM",
          guard: "isPostRAM"
        },
        {
          guard: "isPublicClientUnavailable",
          actions: "stopLiveSaleDataPollingMachine"
        },
        {
          actions: "spawnLiveSaleDataPollingMachine"
        }
      ]
    },
    readyForPurchase: {
      description: "This state is activated when all necessary context is available and the project is in a purchasable state. The corresponding machine (currently only purchase initiation, with bidding to be implemented) is initiated to manage the sale process. If the project becomes non-purchasable or any essential context is lost, the machine reverts to the 'idle' state.",
      entry: {
        type: "spawnAndAssignPurchaseInitiationMachine"
      },
      always: [
        {
          target: "idle",
          guard: "isNotPurchasable",
          actions: {
            type: "stopAndAssignPurchaseInitiationMachine"
          }
        }
      ]
    },
    readyForRam: {
      entry: {
        type: "spawnAndAssignRamMachine"
      },
      always: [
        {
          target: "idle",
          guard: "isNotRAMBiddable",
          actions: "stopAndAssignRamMachine"
        }
      ]
    },
    postRAM: {
      entry: {
        type: "spawnAndAssignPostRAMMachine"
      }
    },
    projectSaleComplete: {},
    error: {},
    projectIneligibleForPrimarySale: {}
  }
});

// src/machines/project-sale-manager-machine/utils.ts
var import_viem5 = require("viem");
var ProjectIneligibleForPrimarySaleError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "ProjectIneligibleForPrimarySaleError";
  }
};
var getProjectDetailsFragmentsDocument = graphql(
  /* GraphQL */
  `
  fragment ProjectDetails on projects_metadata {
    id
    artist_address
    artist_name
    complete
    start_datetime
    auction_start_time
    auction_end_time
    aspect_ratio
    name
    invocations
    max_invocations
    paused

    featured_token {
      media_url
    }

    contract {
      address
      contract_type

      default_vertical {
        category {
          hosted
        }
      }
    }

    minter_configuration {
      ...MinterConfigurationDetails
    }
  }

  fragment MinterConfigurationDetails on project_minter_configurations {
    currency_symbol
    currency_address
    base_price

    extra_minter_details
    offchain_extra_minter_details

    minter {
      ...MinterDetails
    }
  }

  fragment MinterDetails on minters_metadata {
    address
    minter_type
    type {
      description_template
    }
  }
`
);
var getProjectDetailsDocument = graphql(
  /* GraphQL */
  `
  query GetProjectDetails($projectId: String!) {
    projects_metadata_by_pk(id: $projectId) {
      ...ProjectDetails
    }
  }
`
);
var PROJECT_MINTER_STATE = {
  PreAuction: "PreAuction",
  LiveAuction: "LiveAuction",
  // Ram bid flow - all data available
  PostAuctionSellOutAdminArtistMint: "PostAuctionSellOutAdminArtistMint",
  // Idle - live sale data available, user bids not available
  PostAuctionOpenMint: "PostAuctionOpenMint",
  // Purchase flow - live sale data available, user bids currently not available
  PostAuctionAllBidsHandled: "PostAuctionAllBidsHandled"
  // Idle or potentially complete
};
var ProjectMinterStateNumberToEnum = {
  0: PROJECT_MINTER_STATE.PreAuction,
  1: PROJECT_MINTER_STATE.LiveAuction,
  2: PROJECT_MINTER_STATE.PostAuctionSellOutAdminArtistMint,
  3: PROJECT_MINTER_STATE.PostAuctionOpenMint,
  4: PROJECT_MINTER_STATE.PostAuctionAllBidsHandled
};
function isProjectComplete(project, liveSaleData) {
  var _a, _b;
  return !isRAMMinterType((_b = (_a = project == null ? void 0 : project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type) && Boolean(
    (project == null ? void 0 : project.complete) || liveSaleData && liveSaleData.completedTimestamp
  );
}
function isProjectIneligibleForPrimarySale(context) {
  var _a, _b;
  return Boolean(
    context.projectIneligibleReason || !context.project || !context.project.minter_configuration || !isSupportedMinterType(
      (_b = (_a = context.project.minter_configuration) == null ? void 0 : _a.minter) == null ? void 0 : _b.minter_type
    )
  );
}
function isProjectPurchasable(context) {
  const { artblocksClient, project, liveSaleData } = context;
  const walletClient = artblocksClient.getWalletClient();
  if (!liveSaleData) {
    return false;
  }
  if (!walletClient || !walletClient.account) {
    return false;
  }
  if (!project) {
    return false;
  }
  if (isProjectComplete(project, liveSaleData)) {
    return false;
  }
  if (isProjectIneligibleForPrimarySale(context)) {
    return false;
  }
  if (liveSaleData.ramMinterAuctionDetails) {
    const { maxHasBeenInvoked, projectMinterState } = liveSaleData.ramMinterAuctionDetails;
    const isPostAuctionOpenMint = projectMinterState === PROJECT_MINTER_STATE.PostAuctionOpenMint;
    const isPostAuctionAllBidsHandled = projectMinterState === PROJECT_MINTER_STATE.PostAuctionAllBidsHandled;
    const isPostAuctionState = isPostAuctionOpenMint || isPostAuctionAllBidsHandled;
    if (maxHasBeenInvoked || !isPostAuctionState) {
      return false;
    }
  }
  return true;
}
function isProjectRAMBiddable(context) {
  const { artblocksClient, project, liveSaleData } = context;
  const walletClient = artblocksClient.getWalletClient();
  if (!liveSaleData) {
    return false;
  }
  if (!walletClient || !walletClient.account) {
    return false;
  }
  if (!project) {
    return false;
  }
  if (!liveSaleData.ramMinterAuctionDetails) {
    return false;
  }
  const auctionDetails = liveSaleData.ramMinterAuctionDetails;
  if (auctionDetails.projectMinterState !== PROJECT_MINTER_STATE.LiveAuction) {
    return false;
  }
  return true;
}
function isProjectPostRAM(context) {
  const { artblocksClient, project, liveSaleData } = context;
  const walletClient = artblocksClient.getWalletClient();
  if (!liveSaleData) {
    return false;
  }
  if (!walletClient || !walletClient.account) {
    return false;
  }
  if (!project) {
    return false;
  }
  if (!liveSaleData.ramMinterAuctionDetails) {
    return false;
  }
  if (isProjectRAMBiddable(context)) {
    return false;
  }
  if (isProjectPurchasable(context)) {
    return false;
  }
  const { projectMinterState } = liveSaleData.ramMinterAuctionDetails;
  return projectMinterState === PROJECT_MINTER_STATE.PostAuctionOpenMint || projectMinterState === PROJECT_MINTER_STATE.PostAuctionAllBidsHandled || projectMinterState === PROJECT_MINTER_STATE.PostAuctionSellOutAdminArtistMint;
}
function bigintTimestampToDate(bigintTimestamp) {
  return new Date(Number(bigintTimestamp) * 1e3);
}

// src/machines/utils.ts
var import_xstate7 = require("xstate");
var SUPPORTED_MINTER_TYPES = [
  "MinterSetPriceV5" /* MinterSetPriceV5 */,
  "MinterDAExpV5" /* MinterDaExpV5 */,
  "MinterDALinV5" /* MinterDaLinV5 */,
  "MinterSetPriceMerkleV5" /* MinterSetPriceMerkleV5 */,
  "MinterDALinHolderV5" /* MinterDaLinHolderV5 */,
  "MinterDAExpHolderV5" /* MinterDaExpHolderV5 */,
  "MinterSetPriceHolderV5" /* MinterSetPriceHolderV5 */,
  "MinterDAExpSettlementV3" /* MinterDaExpSettlementV3 */,
  "MinterRAMV0" /* MinterRamv0 */,
  "MinterSetPriceERC20V5" /* MinterSetPriceErc20V5 */,
  "MinterMinPriceV0" /* MinterMinPriceV0 */,
  "MinterMinPriceMerkleV0" /* MinterMinPriceMerkleV0 */
];
var SUPPORTED_SETTLEMENT_CLAIM_MINTER_TYPES = [
  "MinterDAExpSettlementV0" /* MinterDaExpSettlementV0 */,
  "MinterDAExpSettlementV1" /* MinterDaExpSettlementV1 */,
  "MinterDAExpSettlementV2" /* MinterDaExpSettlementV2 */,
  "MinterDAExpSettlementV3" /* MinterDaExpSettlementV3 */
];
var MERKLE_MINTER_TYPES = [
  "MinterSetPriceMerkleV5" /* MinterSetPriceMerkleV5 */,
  "MinterMinPriceMerkleV0" /* MinterMinPriceMerkleV0 */
];
var HOLDER_MINTER_TYPES = [
  "MinterDALinHolderV5" /* MinterDaLinHolderV5 */,
  "MinterDAExpHolderV5" /* MinterDaExpHolderV5 */,
  "MinterSetPriceHolderV5" /* MinterSetPriceHolderV5 */
];
var ERC20_MINTER_TYPES = ["MinterSetPriceERC20V5" /* MinterSetPriceErc20V5 */];
var RAM_MINTER_TYPES = ["MinterRAMV0" /* MinterRamv0 */];
function isSupportedMinterType(minterType) {
  return SUPPORTED_MINTER_TYPES.includes(
    minterType
  );
}
function isMerkleMinterType(minterType) {
  return MERKLE_MINTER_TYPES.includes(minterType);
}
function isHolderMinterType(minterType) {
  return HOLDER_MINTER_TYPES.includes(minterType);
}
function isERC20MinterType(minterType) {
  return ERC20_MINTER_TYPES.includes(minterType);
}
function isRAMMinterType(minterType) {
  return RAM_MINTER_TYPES.includes(minterType);
}
function isUserRejectedError(error) {
  if (error instanceof import_viem6.TransactionExecutionError) {
    return Boolean(
      error.cause.walk((e) => e instanceof import_viem6.UserRejectedRequestError)
    );
  }
  if (error instanceof Error && error.message.includes("User denied transaction")) {
    return true;
  }
  return false;
}
function getMessageFromError(error, fallbackMessage) {
  if (error instanceof import_viem6.BaseError) {
    return error.shortMessage;
  }
  if (typeof error === "object" && error && "shortMessage" in error && typeof error.shortMessage === "string") {
    return error.shortMessage;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return fallbackMessage != null ? fallbackMessage : "Unknown error";
}
function getCoreContractAddressAndProjectIndexFromProjectId(projectId) {
  const [coreContractAddress, projectIndex] = projectId.split("-");
  if (!coreContractAddress || !projectIndex) {
    throw new Error("Invalid project ID");
  }
  return {
    coreContractAddress,
    projectIndex: BigInt(projectIndex)
  };
}

// src/machines/excess-settlement-funds-manager-machine/receipt-polling-machine.ts
var receiptSettlementDataFragment = graphql(
  /* GraphQL */
  `
  fragment ReceiptSettlementData on receipt_metadata {
    id
    project {
      id
      name
      index
      contract_address
      featured_token {
        media_url
      }
      vertical_name
      vertical {
        display_name
        category_name
      }
      contract {
        name
      }
    }

    minter {
      address
      minter_type
    }

    project_minter_configuration {
      extra_minter_details
    }
    excess_settlement_funds
  }
`
);
var getReceiptsWithExcessSettlementFundsForUserDocument = graphql(
  /* GraphQL */
  `
    query GetReceiptsWithExcessSettlementFundsForUser(
      $userAddress: String!
      $supportedMinterTypes: [minter_type_names_enum!]!
    ) {
      receipt_metadata(
        where: {
          user_address: { _eq: $userAddress }
          excess_settlement_funds: { _neq: "0" }
          minter: { type: { type: { _in: $supportedMinterTypes } } }
          project_minter_configuration: {
            _or: [
              { complete: { _eq: true } }
              { auction_end_time: { _lt: "now()" } }
            ]
          }
        }
      ) {
        ...ReceiptSettlementData
      }
    }
  `
);
var WalletClientUnavailableError = class extends Error {
  constructor() {
    super("Wallet client is unavailable");
    this.name = "WalletClientUnavailableError";
  }
};
var MAX_ERROR_COUNT = 5;
var receiptPollingMachine = (0, import_xstate8.setup)({
  types: {
    input: {},
    context: {}
  },
  actors: {
    fetchReceiptsForUser: (0, import_xstate8.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input
      }) {
        var _a;
        const { artblocksClient } = input;
        const walletClient = artblocksClient.getWalletClient();
        const userAddress = (_a = walletClient == null ? void 0 : walletClient.account) == null ? void 0 : _a.address;
        if (!userAddress) {
          throw new WalletClientUnavailableError();
        }
        const res = yield artblocksClient.graphqlRequest(
          getReceiptsWithExcessSettlementFundsForUserDocument,
          {
            userAddress: userAddress.toLowerCase(),
            supportedMinterTypes: SUPPORTED_SETTLEMENT_CLAIM_MINTER_TYPES
          }
        );
        const receipts = res.receipt_metadata;
        return receipts;
      })
    )
  },
  actions: {
    assignReceipts: (0, import_xstate8.assign)({
      receipts: (_, params) => params.receipts
    }),
    sendReceiptsToParent: (0, import_xstate8.sendParent)(
      (_, params) => {
        return {
          type: "RECEIPTS_FETCHED",
          receipts: params.receipts
        };
      }
    ),
    assignErrorMessageCountsFromError: (0, import_xstate8.assign)({
      errorMessageCounts: ({ context }, params) => {
        var _a;
        const errorMessage = getMessageFromError(params.error);
        return __spreadProps(__spreadValues({}, context.errorMessageCounts), {
          [errorMessage]: ((_a = context.errorMessageCounts[errorMessage]) != null ? _a : 0) + 1
        });
      }
    }),
    resetErrorMessageCounts: (0, import_xstate8.assign)({
      errorMessageCounts: {}
    })
  },
  guards: {
    isWalletClientUnavailableError: (_, { error }) => {
      return error instanceof WalletClientUnavailableError;
    },
    isMaxErrorCountReached: ({ context }, { error }) => {
      const errorMessage = getMessageFromError(error);
      return context.errorMessageCounts[errorMessage] + 1 >= MAX_ERROR_COUNT;
    }
  },
  delays: {
    pollingInterval: ({ context }) => context.pollingInterval
  }
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QCcwGMwEsAOAXACgPYA2xmAdlALICGaAFhWAHQBmYuDFUASulnlgBiCIXIsKAN0IBrFqgw4CJMpVpdxbDht78lsBFMJoauTGIDaABgC61m4lDZCsTGbGOQAD0QAWAOy+zABMwQBsAKz+AIz+cQDM8QAcEQA0IACeiPEAnPHMEQG+YcG+0Vahgf4AvtXpCgLKpNzqjJrsnG26ioJCYMjIhMjM2MSmrEMAtswNSkTNanRtLB06fD24BkYm7uT29p7OrruePghFIeFRsQnJaZmISdHMvjlvb-HRKfH+OWG19T0eHmqmoSyYWk63HWjWE-UGw1G4ymMyBTVBrQhqy6MP0hnI0h25j2tgs0QcSBARzcxNOfkCl0iMTi-kSKXSWQQwSsVmYSTC0V8SSS8SscWiwQBIFmwJULXBmgA7jQaZQhF5YLhTCwaKxcP0ABTlHlWACUQhl6PlGhYytVUAOlOpJ0pZxyEV5vmC0S+VjCb2iESeHMQJTCzDeVkFwTe4Wi-yl5EIEDgnktIOty0OLhpHldiAAtNFEsx-VZkv4RULvb4QwgC+GTTzRfEAmF-UKpem5YsbZC1mj4E6cy7QGcCylSzly0lK62kjW658gu7csa-RFRTU6tK0Rne8tmHazJRs8dafmEO6cswrHkrBF20G7zl-HXSv4+ck-WFil9K2E26Ahs+5gn28JDGeubkHSV7RDeVgpH8OS+FG8QRG8dYLi87z+OWuSVjkpS1LUQA */
  id: "receiptPollingMachine",
  initial: "fetchingReceipts",
  context: ({ input }) => ({
    artblocksClient: input.artblocksClient,
    errorMessageCounts: {},
    pollingInterval: input.pollingInterval
  }),
  input: {},
  states: {
    fetchingReceipts: {
      description: "Fetches receipts with excess settlement funds for the user.",
      invoke: {
        src: "fetchReceiptsForUser",
        input: ({ context }) => ({
          artblocksClient: context.artblocksClient
        }),
        onDone: {
          description: "Assigns the fetched receipts and sends them to parent. Transition to waiting state before polling again.",
          target: "waiting",
          actions: [
            {
              type: "assignReceipts",
              params({ event }) {
                return { receipts: event.output };
              }
            },
            {
              type: "sendReceiptsToParent",
              params: ({ event }) => {
                return {
                  receipts: event.output
                };
              }
            },
            "resetErrorMessageCounts"
          ]
        },
        onError: [
          {
            description: "If we've hit the same error too many times transition to the error state to stop polling.",
            target: "error",
            guard: {
              type: "isMaxErrorCountReached",
              params: ({ event }) => {
                return {
                  error: event.error
                };
              }
            }
          },
          {
            description: "If fetching receipts fails, first assume the error is transient and retry after a delay.",
            target: "waiting",
            actions: [
              {
                type: "assignErrorMessageCountsFromError",
                params({ event }) {
                  return { error: event.error };
                }
              }
            ]
          }
        ]
      }
    },
    waiting: {
      after: {
        pollingInterval: "fetchingReceipts"
      }
    },
    error: {
      description: "Fetching receipts has failed too many times. Stop polling.",
      type: "final"
    }
  }
});

// src/machines/excess-settlement-funds-claim-machine/index.ts
var import_viem7 = require("viem");
var import_xstate9 = require("xstate");

// abis/iSharedMinterDAExpSettlementV0Abi.ts
var iSharedMinterDAExpSettlementV0Abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "getNumSettleableInvocations",
    outputs: [
      {
        internalType: "uint256",
        name: "numSettleableInvocations",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      },
      {
        internalType: "address",
        name: "walletAddress",
        type: "address"
      }
    ],
    name: "getProjectExcessSettlementFunds",
    outputs: [
      {
        internalType: "uint256",
        name: "excessSettlementFundsInWei",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "getProjectLatestPurchasePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "latestPurchasePrice",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minimumPriceDecayHalfLifeSeconds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "coreContract",
        type: "address"
      }
    ],
    name: "reclaimProjectExcessSettlementFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minimumPriceDecayHalfLifeSeconds",
        type: "uint256"
      }
    ],
    name: "setMinimumPriceDecayHalfLifeSeconds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// abis/iUnsharedDAExpSettlementAbi.ts
var iUnsharedDAExpSettlementAbi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      }
    ],
    name: "reclaimProjectExcessSettlementFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_projectId",
        type: "uint256"
      }
    ],
    name: "reclaimProjectExcessSettlementFundsTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_projectIds",
        type: "uint256[]"
      }
    ],
    name: "reclaimProjectsExcessSettlementFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "_projectIds",
        type: "uint256[]"
      }
    ],
    name: "reclaimProjectsExcessSettlementFundsTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/machines/excess-settlement-funds-claim-machine/index.ts
var getReceiptDocument = graphql(
  /* GraphQL */
  `
  query GetReceipt($id: String!) {
    receipt_metadata_by_pk(id: $id) {
      id
      excess_settlement_funds
    }
  }
`
);
var SYNC_POLLING_INTERVAL = 5e3;
var excessSettlementFundsClaimMachine = (0, import_xstate9.setup)({
  types: {
    input: {},
    context: {},
    events: { type: "INITIATE_CLAIM" }
  },
  actors: {
    initiateExcessSettlementFundsClaim: (0, import_xstate9.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input: { receipt, artblocksClient }
      }) {
        const walletClient = artblocksClient.getWalletClient();
        const publicClient = artblocksClient.getPublicClient();
        if (!publicClient) {
          throw new Error("Public client is not available");
        }
        if (!(walletClient == null ? void 0 : walletClient.account)) {
          throw new Error("Wallet client is not connected to an account");
        }
        const isSharedMinter = receipt.minter.minter_type === "MinterDAExpSettlementV3" /* MinterDaExpSettlementV3 */;
        const contractConfig = {
          address: receipt.minter.address,
          client: {
            public: publicClient,
            wallet: walletClient
          }
        };
        const projectIndex = BigInt(receipt.project.index);
        if (isSharedMinter) {
          const minter = (0, import_viem7.getContract)(__spreadProps(__spreadValues({}, contractConfig), {
            abi: iSharedMinterDAExpSettlementV0Abi
          }));
          const { request } = yield minter.simulate.reclaimProjectExcessSettlementFunds(
            [projectIndex, receipt.project.contract_address],
            { account: walletClient.account.address }
          );
          return walletClient.writeContract(request);
        } else {
          const minter = (0, import_viem7.getContract)(__spreadProps(__spreadValues({}, contractConfig), {
            abi: iUnsharedDAExpSettlementAbi
          }));
          const { request } = yield minter.simulate.reclaimProjectExcessSettlementFunds(
            [projectIndex],
            { account: walletClient.account.address }
          );
          return walletClient.writeContract(request);
        }
      })
    ),
    awaitClaimConfirmations: (0, import_xstate9.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input: { txHash, artblocksClient }
      }) {
        const publicClient = artblocksClient.getPublicClient();
        if (!publicClient) {
          throw new Error("Public client is not available");
        }
        if (!txHash) {
          throw new Error("Transaction hash is unavailable");
        }
        yield publicClient.waitForTransactionReceipt({
          hash: txHash
        });
      })
    ),
    fetchReceipt: (0, import_xstate9.fromPromise)(
      (_0) => __async(void 0, [_0], function* ({
        input: { receipt, artblocksClient }
      }) {
        const res = yield artblocksClient.graphqlRequest(getReceiptDocument, {
          id: receipt.id
        });
        return res.receipt_metadata_by_pk;
      })
    )
  },
  guards: {
    hasExcessSettlementFunds: (_, { receipt }) => {
      if ((receipt == null ? void 0 : receipt.excess_settlement_funds) === "0") {
        return false;
      }
      return true;
    },
    isUserRejectedError: (_, { error }) => {
      return isUserRejectedError(error);
    }
  },
  actions: {
    assignTxHash: (0, import_xstate9.assign)({
      txHash: (_, params) => params.txHash
    })
  }
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QAoC2BDAxgCwJYDswBKAOlwgBswBiASQDlaAVWgQSYFEB9AYQBlWtALIBtAAwBdRKAAOAe1i4ALrjn5pIAB6IAtAFYAHADYSBgCxmjATgMAmAOxijZpwBoQAT0R6zJMWdsARls9Iz0xA0MQgF9o9zQsPEJSAmVcdBV8KFgeCnRcVGoINTAyfAA3OQBrUoScAmIytIyCbNz81AQCSswWtXEJAY15RRU1DW0EAGYxKxJbA0CrWynbKyWjAys9dy8EHXtbPztIq3sAwPCxPVj4jHrkppUWrJy8guowACcvuS+SGR5JQAMz+qBIdSSjVSz0ybXenW6cl6Y3wAyGSBAIzS40xkzMU1M9kCWym5gcQQM9h2nkQDgMJBsZkCEQMBhmYimXNuIEhDRS+GacLeHU+Pz+AKBoK+4L5jxh6WF7QKXQqyL6aMkIkCUkx2NRE0QhxIemCegc2ymgSmPlsu0QAV85pcC3CekcZnsPLljXQAHd8nDlageGpgbgZRrYEUSmVKjUIfcoaR-YHWsHQ-hw5HUbBVT0NejJMMFDj1HjEIFAkZ7CanLZrvZVpFrPb9lW5s7-EY1norDaAt6k-ySKm0lkM2GIxhc2Lfv9ARlpbLh48x0GEZnszPVPg80iUbui7rZKWDRWEPZjQTPetrJcjGJAm2pnNrUYNlMLttbEYh4kR2BMAlAeKAACUwEwMBcBkJQY0IONqlqVdGiAkCknAyDoNg-N1VRY8S1GXdDQQJYrxIAkG0cMRiUCT0jDbFk9EZSIXBvM4q2cf8HlQ4DQIgqCYLg4oEKRBMfVIND+KwoTcMPfotR1QiyxIlYG3mbYxGuYJ7GMKY2x0a1CTWLkuTMU06L0KYvTiXkUMkviMIE7C4O+edJSXMFEwAx4pKcmScIPQstWLPUz2Ii93zmKkVksBsLC-Gk9kWeYZh7KsLOtWwzG45MSADccoGoTRYCUDJSnQYElG+ZArjEIhqAk-K0yyDFTyI3FQEmEkvxIK9-G2KtrIWO1aXbbK+vCOwrx8RYzCsP9bKaty-mK0rytHKqapZLSGuW8UvjarFws6rRdCMZwSFfV8wi-GYZmfMa+0CEgqxJFZq1mc0DFykdYAAV0wKDYGjEqyuqzbqq+ZAG12xr7JIAGgbgWAjv1CKurpLZOxcPR3XmmwbQMqxfGu5lqx8AIths2z8DkCA4A0CTlPPTH9gWo4rLsVYfwWIx9LGnQ1L6iJZk5DlstCX75UoMAWYxs72bok0yTU3m9LbHw-AuKZnHWFYScWu4fOhQVYVaEUCnl07JkMpZTDJFkrAWnn1jbAl5i0gx-BWYlDDEGIloR9d003Kcc13eAwo68s2epBkQmCfxdbMcxFgMuinWyrSvyrcyvyNuyTYc9DWmcoTrdjxXLnCEgwgW0J7H7X37AziwTWzzlyfzyxpcaAq4Ur1S6MJEmLGz4k7AYwXrV8JueasoIe0fKY+9IFaviHi8FmV-wlnmtPDgcTXVlezOwifR9Ih+oPi8RwHgaj9qVO372Xt0gPnDx4IuTb5iG0WAHa4PZZjcliNEIAA */
  initial: "idle",
  context: ({ input }) => ({
    artblocksClient: input.artblocksClient,
    receipt: input.receipt
  }),
  states: {
    idle: {
      on: {
        INITIATE_CLAIM: "initiatingsClaim"
      }
    },
    initiatingsClaim: {
      invoke: {
        src: "initiateExcessSettlementFundsClaim",
        input: ({ context: { receipt, artblocksClient } }) => ({
          receipt,
          artblocksClient
        }),
        onDone: {
          target: "awaitingClaimConfirmations",
          actions: {
            type: "assignTxHash",
            params({ event }) {
              return { txHash: event.output };
            }
          }
        },
        onError: [
          {
            target: "idle",
            guard: {
              type: "isUserRejectedError",
              params({ event }) {
                return {
                  error: event.error
                };
              }
            }
          },
          {
            target: "error"
          }
        ]
      }
    },
    awaitingClaimConfirmations: {
      invoke: {
        src: "awaitClaimConfirmations",
        input: ({ context: { txHash, artblocksClient } }) => ({
          txHash,
          artblocksClient
        }),
        onDone: "fetchingReceipt",
        onError: "error"
      }
    },
    fetchingReceipt: {
      invoke: {
        src: "fetchReceipt",
        input: ({ context: { receipt, artblocksClient } }) => ({
          receipt,
          artblocksClient
        }),
        onDone: [
          {
            target: "waiting",
            guard: {
              type: "hasExcessSettlementFunds",
              params({ event }) {
                return {
                  receipt: event.output
                };
              }
            }
          },
          {
            target: "success"
          }
        ],
        onError: "error"
      }
    },
    waiting: {
      after: {
        [SYNC_POLLING_INTERVAL]: "fetchingReceipt"
      }
    },
    error: {
      after: {
        1e3: "idle"
      }
    },
    success: {
      after: {
        2e3: {
          actions: (0, import_xstate9.sendParent)(({ context }) => {
            return {
              type: "EXCESS_SETTLEMENT_FUNDS_CLAIMED",
              receiptId: context.receipt.id
            };
          })
        }
      }
    }
  }
});

// src/machines/excess-settlement-funds-manager-machine/index.ts
var DEFAULT_RECEIPT_POLLING_INTERVAL = 6e4;
var excessSettlementFundsManagerMachine = (0, import_xstate10.setup)({
  types: {
    input: {},
    context: {},
    events: {}
  },
  actors: {
    receiptPollingMachine,
    excessSettlementFundsClaimMachine
  },
  actions: {
    assignArtblocksClient: (0, import_xstate10.assign)({
      artblocksClient: (_, params) => params.artblocksClient
    })
  },
  guards: {
    hasClaimableExcessSettlementFunds: (_, { receipts }) => {
      return receipts.length > 0;
    },
    walletClientAvailable: (_, { artblocksClient }) => {
      return Boolean(artblocksClient.getWalletClient());
    },
    walletClientUnavailable: (_, { artblocksClient }) => {
      return !artblocksClient.getWalletClient();
    }
  }
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5RgB4GM6wMpgC64BswBbMAO1wDEBXMiWAWQEMymYAnZtACwEsywAYgCiADQDCwrFgD6WYQBUFAGWENhAOQUzKAVQ0ARWeOUBBAJLqDAbQAMAXUSgADgHtYvXL1dknIFIgAjLYArCEAdADsAGwATJG2ACwAnGGx0RkANCAAnogAtADMtsnhsclxKcm2kQAcIYWFiQC+zdmoGLDYeIQk5FS09MysHFx8AuFMaGiutLi6rABuTLwETABGRIKmAEraAELKAPLiANLGyuaa2roACgamCsI2Dn5uHl4+fgEI+anhiRC8RiiUS0Sa0VsgWyeV+-xSkWCTUKwVstRKrXa6EwOHwRFIFBodEYLDYYE4U3GYEm01mFAWTGWqw2W12B2OZwuVy0MjuDyeNkCjiQIHenm8vhFP3y0USAMKiIaiUK6QasViMKCtli4UCgVioXRsRVyXKkUx4GxXVxvQJA2JwzJFJ4-GpBF4sFw5H4UEornYOzAGF4zlwsG2exkhxO5xkJm5N3uj2edmFLnc4q+UsQtT1ANqtUKDSatjRhVqmrhtQBIWCyuiFVs0UihQtHRxPXx-SJQ1Jo0prvC7s93rIvv9geDofDO2EknMtwUskoinEAAkU68RWLPpLQD8whFarEQrKDSiSnrKy2yqfooEG4DC7Fla02iAyK4IHA-O3rZ2+kJQYSRGckxldN4M13b4CgVWxdUKaJj3iRICzLSt8kCepwlSOsGmPEI0ViNsrW6PFAPtXtQOdKkaRmOYGSZNZNjASCPglGDfhVHVAkQ5DIlQ9FC0rRpAnCWpZUiMIMmiU8sJIzoyNtbtgMdfsXQmYcvTIH0-QDIMwBDMM2MzPd-EQFJqwEpDTWKSIW2NSIMIqcJtVCeJkiNWoKmiN9miAA */
  id: "excessSettlementFundsManagerMachine",
  initial: "accountUnavailable",
  context: ({ input }) => {
    var _a;
    return {
      artblocksClient: input.artblocksClient,
      receiptPollingInterval: (_a = input.receiptPollingInterval) != null ? _a : DEFAULT_RECEIPT_POLLING_INTERVAL
    };
  },
  on: {
    EXCESS_SETTLEMENT_FUNDS_CLAIMED: {
      actions: (0, import_xstate10.enqueueActions)(({ event, context, enqueue }) => {
        const { claimMachines = /* @__PURE__ */ new Map() } = context;
        const updatedClaimMachines = new Map(claimMachines);
        const { receiptId } = event;
        if (claimMachines.has(receiptId)) {
          enqueue.stopChild(receiptId);
          updatedClaimMachines.delete(receiptId);
        }
        enqueue.assign({ claimMachines: updatedClaimMachines });
      })
    }
  },
  states: {
    accountUnavailable: {
      on: {
        ART_BLOCKS_CLIENT_UPDATED: [
          {
            target: "listeningForReceipts",
            guard: {
              type: "walletClientAvailable",
              params: ({ event }) => ({
                artblocksClient: event.artblocksClient
              })
            },
            actions: {
              type: "assignArtblocksClient",
              params: ({ event }) => ({
                artblocksClient: event.artblocksClient
              })
            }
          },
          {
            actions: {
              type: "assignArtblocksClient",
              params: ({ event }) => ({
                artblocksClient: event.artblocksClient
              })
            }
          }
        ]
      }
    },
    listeningForReceipts: {
      entry: (0, import_xstate10.enqueueActions)(({ context, enqueue }) => {
        const { artblocksClient, receiptPollingInterval } = context;
        const walletClient = artblocksClient.getWalletClient();
        const publicClient = artblocksClient.getPublicClient();
        if (!walletClient || !publicClient) {
          return;
        }
        enqueue.spawnChild("receiptPollingMachine", {
          id: "receiptPollingMachine",
          systemId: "receiptPollingMachine",
          input: {
            artblocksClient,
            pollingInterval: receiptPollingInterval
          }
        });
      }),
      on: {
        ART_BLOCKS_CLIENT_UPDATED: {
          target: "accountUnavailable",
          guard: {
            type: "walletClientUnavailable",
            params: ({ event }) => ({
              artblocksClient: event.artblocksClient
            })
          },
          actions: [
            {
              type: "assignArtblocksClient",
              params: ({ event }) => ({
                artblocksClient: event.artblocksClient
              })
            },
            (0, import_xstate10.enqueueActions)(({ context, enqueue }) => {
              enqueue.stopChild("receiptPollingMachine");
              const {
                claimMachines = /* @__PURE__ */ new Map()
              } = context;
              claimMachines.forEach((_, id) => {
                enqueue.stopChild(id);
              });
              enqueue.assign({ claimMachines: /* @__PURE__ */ new Map() });
            })
          ]
        },
        RECEIPTS_FETCHED: [
          {
            actions: (0, import_xstate10.enqueueActions)(({ event, enqueue, context }) => {
              const {
                claimMachines = /* @__PURE__ */ new Map(),
                artblocksClient
              } = context;
              const walletClient = artblocksClient.getWalletClient();
              const publicClient = artblocksClient.getPublicClient();
              const updatedClaimMachines = new Map(claimMachines);
              if (!publicClient || !walletClient) {
                enqueue.assign({
                  claimMachines: updatedClaimMachines
                });
                return;
              }
              const receipts = event.receipts;
              const receiptsMap = new Map(
                receipts.map((receipt) => [receipt.id, receipt])
              );
              claimMachines.forEach((claimMachine, id) => {
                const snapshot = claimMachine.getSnapshot();
                if (!receiptsMap.has(id) && snapshot.matches("idle")) {
                  enqueue.stopChild(id);
                  updatedClaimMachines.delete(id);
                }
              });
              receipts.forEach((receipt) => {
                if (!claimMachines.has(receipt.id)) {
                  enqueue.assign({
                    claimMachines: ({ spawn }) => {
                      const claimMachine = spawn(
                        "excessSettlementFundsClaimMachine",
                        {
                          id: receipt.id,
                          systemId: receipt.id,
                          input: {
                            receipt,
                            artblocksClient
                          }
                        }
                      );
                      updatedClaimMachines.set(receipt.id, claimMachine);
                      return updatedClaimMachines;
                    }
                  });
                }
              });
            })
          }
        ]
      }
    }
  }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  excessSettlementFundsManagerMachine
});
